/* An option value as a shopper reads it — the same rule as
   snippets/vro-option-label.liquid: a value entered in capitals ("GOLD",
   "REMY LATOUR MYSTIC") shows in normal case; mixed case, numbers, sizes
   (S, M, XL, 2XL), EDP/EDT/EDC, roman numerals and a few codes stay as
   they are; a word starting with a digit is lower-cased ("100ML"). Display
   only — the value that matches the variant is never changed. */
window.vroOptionLabel = function (text) {
  var t = String(text == null ? '' : text).trim();
  if (t !== t.toUpperCase() || t === t.toLowerCase()) return t;
  var KEEP = '|XS|S|M|L|XL|XXL|XXXL|2XL|3XL|4XL|5XL|6XL|EDP|EDT|EDC|II|III|IV|VI|VII|VIII|IX|XI|XII|UK|US|EU|SPF|PA|PA+|PA++|PA+++|PA++++|HD|LED|USB|UV|AC|DC|TV|XXS|';
  var SMALL = '|OF|AND|FOR|WITH|IN|ON|TO|THE|A|AN|OR|';
  return t.split(' ').map(function (w, wi) {
    return w.split('/').map(function (s) {
      return s.split('-').map(function (p) {
        if (KEEP.indexOf('|' + p + '|') !== -1) return p;
        if (/^[0-9]/.test(p)) return p.toLowerCase();
        if (wi > 0 && SMALL.indexOf('|' + p + '|') !== -1) return p.toLowerCase();
        return p.charAt(0) + p.slice(1).toLowerCase();
      }).join('-');
    }).join('/');
  }).join(' ');
};

document.addEventListener('DOMContentLoaded', function () {

  /* ---------------------------------------------------------
     The page stays put behind an open panel.

     Every drawer and popup (cart, wishlist, profile, categories, login,
     chat, filters, the circle's modals, the reels player) locks scrolling
     by setting body { overflow: hidden }. That no longer held: custom.css
     gives both <html> and <body> overflow-x: hidden, which makes <html>
     the element the page scrolls on, so hiding <body>'s overflow left the
     website free to scroll behind the panel whenever the wheel or a swipe
     ran past the panel's own list.

     One lock for all of them, whichever script opened them: while any is
     open, <html> is locked too (html.vro-scroll-locked in custom.css) and
     the scrollbar's width is kept as padding so nothing jumps sideways. It
     watches for the panels' own open states rather than asking each script
     to call it, so no panel can be missed.
  --------------------------------------------------------- */
  (function () {
    var root = document.documentElement;
    var OPEN = [
      /* Not the Circle page's own panel: it's permanently .is-open because
         it IS the page (circle-panel--static), and counting it locked the
         whole Circle page so it couldn't scroll at all. */
      '.cart-panel.is-open:not(.circle-panel--static)', '.profile-panel.is-open', '.cat-panel.is-open',
      '.login-sheet.is-open', '.chat-dock.is-open', '.plp-sheet-panel.is-open',
      '.vro-reels-modal.is-open', '.circle-modal.is-open', '.modal.show',
      '.community-clip-modal:not([hidden])'
    ].join(',');
    var locked = false;
    var pending = false;
    function wanted() {
      return document.body.style.overflow === 'hidden' || !!document.querySelector(OPEN);
    }
    function apply() {
      pending = false;
      var want = wanted();
      if (want === locked) return;
      locked = want;
      if (want) {
        var gap = window.innerWidth - root.clientWidth;
        if (gap > 0) root.style.setProperty('--vro-scrollbar-gap', gap + 'px');
        root.classList.add('vro-scroll-locked');
      } else {
        root.classList.remove('vro-scroll-locked');
        root.style.removeProperty('--vro-scrollbar-gap');
      }
    }
    function check() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(apply);
    }
    new MutationObserver(check).observe(document.body, {
      subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden']
    });
    check();
  })();

  /* ---------------------------------------------------------
     CLP: restore scroll position after a filter/sort change.
     Applying a filter or sort (snippets/collection-filters.liquid) is a
     real native form submit — Shopify's own faceted filtering, a full
     page GET with filter.* / sort_by params in the URL — not an AJAX
     re-render. That's correct/expected behavior, but the fresh page load
     always lands at the very top, so anyone who'd already scrolled down
     to the filter bar (or past it, browsing results) gets dropped back
     above the hero/breadcrumb and has to scroll all the way down again
     to see what changed. If the URL carries those params, this page load
     came FROM a filter/sort action, so jump straight to the filter bar
     instead — instant, not smooth, so it doesn't fight the browser's own
     paint/scroll-restoration on load. */
  if (/(?:^|[?&])(filter\.|sort_by=)/.test(window.location.search)) {
    var filterBar = document.querySelector('.clp-filterbar');
    if (filterBar) filterBar.scrollIntoView({ behavior: 'instant', block: 'start' });
  }

  /* Updates the header cart badge's number AND its visibility — the badge
     is always in the DOM now (see sections/header.liquid) so this can run
     on every add/remove, including the very first item in an empty cart,
     without needing a page refresh. */
  window.updateCartCount = function (count) {
    /* Every badge: the desktop header's and the phone's bottom-nav one. */
    document.querySelectorAll('.cart-count').forEach(function (countEl) {
      countEl.textContent = count;
      countEl.hidden = count === 0;
    });
  };

  /* Small top-right toast, shown whenever something is added to the cart
     or wishlist (from anywhere: PDP, quick-add on cards, wishlist heart).
     Stacks if several fire in quick succession; each auto-dismisses on
     its own. variant: 'cart' (default) or 'wishlist' just tints the icon. */
  window.showToast = function (message, variant, options) {
    options = options || {};
    var container = document.getElementById('vroToastContainer');
    if (!container) {
      container = document.createElement('div');
      container.id = 'vroToastContainer';
      container.className = 'vro-toast-container';
      document.body.appendChild(container);
    }

    /* With a picture of what was added it becomes a card: the thing, what
       it is, and one way to change it. Without one it stays the tick and a
       line of text it has always been. */
    var rich = !!options.image;
    var toast = document.createElement('div');
    toast.className = 'vro-toast' + (variant ? ' vro-toast--' + variant : '') + (rich ? ' vro-toast--item' : '');

    if (rich) {
      var thumb = document.createElement('span');
      thumb.className = 'vro-toast-thumb';
      var img = document.createElement('img');
      img.src = options.image;
      img.alt = '';
      img.loading = 'lazy';
      thumb.appendChild(img);
      toast.appendChild(thumb);
    } else {
      var icon = document.createElement('span');
      icon.className = 'vro-toast-icon';
      icon.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 12 2 2 4-4"/><circle cx="12" cy="12" r="9"/></svg>';
      toast.appendChild(icon);
    }

    var body = document.createElement('span');
    body.className = 'vro-toast-body';
    var text = document.createElement('span');
    text.className = 'vro-toast-text';
    text.textContent = message;
    body.appendChild(text);
    if (options.subtitle) {
      var sub = document.createElement('span');
      sub.className = 'vro-toast-sub';
      sub.textContent = options.subtitle;
      body.appendChild(sub);
    }
    toast.appendChild(body);

    if (options.actionLabel && options.onAction) {
      var action = document.createElement('button');
      action.type = 'button';
      action.className = 'vro-toast-action';
      action.textContent = options.actionLabel;
      action.addEventListener('click', function () {
        toast.classList.remove('is-visible');
        options.onAction();
      });
      toast.appendChild(action);
    }

    container.appendChild(toast);

    requestAnimationFrame(function () { toast.classList.add('is-visible'); });

    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 250);
    }, 2200);
  };

  /* Shopify's CDN sizes on request; asking for a thumbnail rather than the
     full product shot keeps a 40px square from pulling a 2000px file. */
  function toastThumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  /* The line the cart now holds for a variant. Taken from /cart.js, which
     every add path already fetches, rather than from the card that was
     clicked — the cart's own account of what it took, and the same shape
     wherever the add came from. */
  function cartLineFor(cart, variantId) {
    if (!cart || !cart.items || variantId == null) return null;
    var id = String(variantId);
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === id) return cart.items[i];
    }
    return null;
  }

  /* "Added to Cart", with the thing that was added. Every add path calls
     this instead of writing its own toast, so the PDP, a card's (+) and
     the quick-add modal all say it the same way. A line we cannot find,
     or a product with no image, falls back to the plain toast rather than
     to an empty frame. */
  window.showCartToast = function (cart, variantId) {
    window.showCartToastForLine(cartLineFor(cart, variantId));
  };

  /* The same toast, from the line itself. /cart/add.js already answers with
     what it took, so an add does not have to fetch the whole cart back
     before it can say what landed. */
  window.showCartToastForLine = function (line) {
    if (!line || !line.image) { window.showToast('Added to cart', 'cart'); return; }
    window.showToast('Added to Cart', 'cart', {
      image: toastThumb(line.image),
      subtitle: [line.vendor, line.product_title].filter(Boolean).join(' · '),
      actionLabel: 'Change',
      /* The cart panel is where a quantity changes or a line goes, so
         "Change" opens the one this theme already has. */
      onAction: function () {
        if (window.VroCartPanel && window.VroCartPanel.open) { window.VroCartPanel.open(); return; }
        var opener = document.querySelector('[data-cart-panel-open]');
        if (opener) opener.click();
      }
    });
  };

  /* Whether an add opens the cart panel on its own.

     Not on a phone. There the panel is a full-screen sheet, so opening it
     takes the shopper off the row they were adding from to show them one
     line they already know about — and getting back is a deliberate
     close. The toast says it landed, names it and pictures it, and
     Change is there for anyone who does want the cart.

     Above 992px the panel is a side drawer that leaves the page beside
     it, so it opens as it always has. Same breakpoint the panel itself
     changes shape at (layout/theme.liquid). */
  window.openCartPanelAfterAdd = function () {
    if (window.matchMedia && window.matchMedia('(max-width: 991.98px)').matches) return;
    var opener = document.querySelector('[data-cart-panel-open]');
    if (opener) opener.click();
  };

  /* ---------------------------------------------------------
     Variant selection -> update hidden variant id input
     Reads product JSON embedded by main-product section via
     window.__PRODUCT_VARIANTS__ if present (optional enhancement).
     Falls back gracefully if not defined.
  --------------------------------------------------------- */
  var form = document.getElementById('AddToCartForm');
  if (form) {
    var variantsJsonEl = document.getElementById('ProductVariantsJson');
    var variants = variantsJsonEl ? JSON.parse(variantsJsonEl.textContent) : null;

    function moneyFormat(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
    }

    function selectedOptionValues() {
      var values = [];
      form.querySelectorAll('[data-option-position]').forEach(function (group) {
        var checked = group.querySelector('.option-swatch:checked');
        values[Number(group.getAttribute('data-option-position')) - 1] = checked ? checked.value : null;
      });
      return values;
    }

    function findMatchingVariant(values) {
      if (!variants) return null;
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return values.every(function (val, i) { return val == null || opts[i] === val; });
      }) || null;
    }

    /* ---- The gallery follows the chosen variant ----------------------

       Three routes, in the order of how much the shop has actually told
       us. Nothing here guesses: where there is no answer the gallery
       stays where the shopper left it.

       1. The variant's own image, when one is assigned in admin. Matched
          on the file name rather than the whole URL: Liquid has resized
          the gallery's copy (?width=1100), so the two URLs agree on
          nothing else.
       2. Failing that, the option value the shopper just moved, read as a
          whole word out of an image's alt text or file name. This
          catalogue's photos are grouped by size exactly that way —
          "1500710-S-1.png", "…-NVY-S-2.webp", alt "XL" — so picking M
          walks the gallery to the M shots even though not one variant
          carries an image of its own.
       3. No match: leave it alone.
    */
    var pdpGallery = document.getElementById('pdpGalleryCarousel');
    var pdpSlides = pdpGallery
      ? Array.prototype.slice.call(pdpGallery.querySelectorAll('.carousel-item'))
      : [];

    function fileKey(url) {
      if (!url) return '';
      return String(url).split('?')[0].split('/').pop().toLowerCase();
    }

    function slideWords(slide) {
      if (slide.__vroWords) return slide.__vroWords;
      var img = slide.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      var file = fileKey(img ? (img.getAttribute('src') || '') : '');
      slide.__vroWords = (alt + ' ' + file).toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
      return slide.__vroWords;
    }

    function slideByFile(want) {
      for (var i = 0; i < pdpSlides.length; i++) {
        var img = pdpSlides[i].querySelector('img');
        if (img && fileKey(img.getAttribute('src')) === want) return i;
      }
      return -1;
    }

    function slideByWord(value) {
      var word = String(value || '').trim().toLowerCase();
      if (!word) return -1;
      for (var i = 0; i < pdpSlides.length; i++) {
        if (slideWords(pdpSlides[i]).indexOf(word) > -1) return i;
      }
      return -1;
    }

    function showVariantMedia(variant, hint) {
      if (!pdpGallery || pdpSlides.length < 2) return;

      var index = -1;
      if (variant && variant.featured_image && variant.featured_image.src) {
        index = slideByFile(fileKey(variant.featured_image.src));
      }
      /* The option just moved first, then whatever else is chosen, so a
         colour picked a moment ago still decides when a size has no
         photos of its own. */
      if (index < 0) {
        var tries = [];
        if (hint) tries.push(hint);
        selectedOptionValues().forEach(function (v) { if (v && tries.indexOf(v) === -1) tries.push(v); });
        for (var t = 0; t < tries.length && index < 0; t++) index = slideByWord(tries[t]);
      }
      if (index < 0) return;

      var current = pdpSlides.indexOf(pdpGallery.querySelector('.carousel-item.active'));
      if (index === current) return;

      var Carousel = window.bootstrap && window.bootstrap.Carousel;
      if (Carousel) {
        Carousel.getOrCreateInstance(pdpGallery, { ride: false }).to(index);
      } else {
        /* Bootstrap absent: move the slides by hand, and tell the
           filmstrip the same way the carousel would have. */
        pdpSlides.forEach(function (slide, i) { slide.classList.toggle('active', i === index); });
        document.querySelectorAll('.pdp-thumb').forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
        });
      }
    }

    /* ---- Combinations the shop does not stock -------------------------

       With four colours against five sizes a product can carry twenty
       variants and stock four of them. The values stay pressable — the
       price and the Sold out button are the honest answer to a tap — but
       they are marked, so nobody works through five sizes to find that
       the colour was never coming. Recomputed on every change, since
       which sizes are sold out depends on the colour beside them. */
    function paintAvailability() {
      if (!variants) return;
      var chosen = selectedOptionValues();
      form.querySelectorAll('[data-option-position]').forEach(function (group) {
        var pos = Number(group.getAttribute('data-option-position')) - 1;
        group.querySelectorAll('.option-swatch').forEach(function (input) {
          var probe = chosen.slice();
          probe[pos] = input.value;
          var match = findMatchingVariant(probe);
          var label = input.closest('.pdp-swatch, .pdp-chip, .pdp-pack-chip, label');
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    /* The address carries the choice, the way a Shopify PDP's does: a
       reload, a share or the back button all land on the same variant
       instead of the product's first one. replaceState, not pushState —
       trying a size is not a page in the shopper's history. */
    function writeVariantUrl(variant) {
      if (!variant || !window.history || !history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      } catch (e) { /* older browser: the form still carries the id */ }
    }

    function applyVariant(variant, hint) {
      var idInput = document.getElementById('ProductVariantId');
      var addBtn = document.getElementById('AddToCartButton');
      var addText = document.getElementById('AddToCartText');
      var buyBtn = document.getElementById('BuyNowButton');
      var buyText = document.getElementById('BuyNowText');
      var priceCurrent = document.getElementById('PdpPriceCurrent');
      var priceCompare = document.getElementById('PdpPriceCompare');
      var priceOff = document.getElementById('PdpPriceOff');

      // Sticky Add-to-Cart bar mirrors — kept in sync with the exact same
      // selected variant as the real form, never a separate source of
      // truth. Elements only exist on the PDP; harmless no-ops elsewhere.
      var stickyAddBtn = document.getElementById('pdpStickyAddBtn');
      var stickyAddText = document.getElementById('pdpStickyAddText');
      var stickyBuyBtn = document.getElementById('pdpStickyBuyBtn');
      var stickyBuyText = document.getElementById('pdpStickyBuyText');
      var stickyPriceCurrent = document.getElementById('pdpStickyPriceCurrent');

      /* The in-stock wording is read off the element rather than written
         here, because none of these four buttons agree on it: "Add to bag"
         and "Buy now" on a product, "Save kit", "Buy Kit Now" and "Add kit
         to cart" on a kit - which is why switching variants on a kit used
         to rename its button to "Add to bag". Liquid stamps the word as
         data-label-available, so it survives a page that rendered sold out;
         reading it back off textContent would have stashed "Sold out" as
         the in-stock label. */
      function setBuyLabel(el, available) {
        if (!el) return;
        el.textContent = available ? (el.getAttribute('data-label-available') || el.textContent) : 'Sold out';
      }

      /* The cart button stays on the page when a variant is out of stock:
         disabled, keeping its own name, with the primary carrying the
         status. It said "Sold out" as well for a while — the same sentence
         twice in two dead controls — and then it was hidden, which took
         the cart affordance off the page altogether. Neither is right, and
         the row should not change shape between a product in stock and one
         that is not. */
      function setSecondaryShown(el, available) {
        if (el) el.hidden = false;
      }
      var stickyPriceCompare = document.getElementById('pdpStickyPriceCompare');
      var stickyThumb = document.getElementById('pdpStickyThumb');

      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (buyBtn) buyBtn.disabled = true;
        if (buyText) buyText.textContent = 'Unavailable';
        if (stickyAddBtn) stickyAddBtn.disabled = true;
        if (stickyBuyBtn) stickyBuyBtn.disabled = true;
        if (stickyBuyText) stickyBuyText.textContent = 'Unavailable';
        /* Same rule for a combination the shop does not stock: one button,
           one word. */
        setSecondaryShown(addBtn, false);
        setSecondaryShown(stickyAddBtn, false);
        /* A combination the shop does not stock still moves the gallery:
           the shopper asked to see that colour, and being out of stock is
           an answer about the cart, not about the photographs. */
        showVariantMedia(null, hint);
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceCurrent) priceCurrent.textContent = moneyFormat(variant.price);
      if (stickyPriceCurrent) stickyPriceCurrent.textContent = moneyFormat(variant.price);
      if (priceCompare && priceOff) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.textContent = moneyFormat(variant.compare_at_price);
          priceCompare.hidden = false;
          var off = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          priceOff.textContent = off + '% off';
          priceOff.hidden = false;
        } else {
          priceCompare.hidden = true;
          priceOff.hidden = true;
        }
      }
      if (stickyPriceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          stickyPriceCompare.textContent = moneyFormat(variant.compare_at_price);
          stickyPriceCompare.hidden = false;
        } else {
          stickyPriceCompare.hidden = true;
        }
      }
      if (stickyThumb && variant.featured_image && variant.featured_image.src) {
        // Variant-specific image (e.g. colour swap) if Shopify has one for
        // this exact variant; otherwise the thumb keeps showing whatever
        // Liquid rendered initially (the product's featured image).
        var src = variant.featured_image.src;
        stickyThumb.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=96';
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (buyBtn) buyBtn.disabled = !variant.available;
      /* Only the primary takes the status; the cart button keeps its name. */
      setBuyLabel(addText, true);
      setBuyLabel(buyText, variant.available);
      if (stickyAddBtn) stickyAddBtn.disabled = !variant.available;
      if (stickyBuyBtn) stickyBuyBtn.disabled = !variant.available;
      setBuyLabel(stickyAddText, true);
      setBuyLabel(stickyBuyText, variant.available);
      setSecondaryShown(addBtn, variant.available);
      setSecondaryShown(stickyAddBtn, variant.available);

      showVariantMedia(variant, hint);
      writeVariantUrl(variant);
    }

    var optionInputs = form.querySelectorAll('.option-swatch');
    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var group = this.closest('[data-option-position]');
        if (group) {
          var label = group.querySelector('.current-option-value');
          if (label) label.textContent = window.vroOptionLabel(this.value);
          group.querySelectorAll('.pdp-swatch, .pdp-chip').forEach(function (el) {
            el.classList.toggle('is-selected', el.contains(this));
          }, this);
        }
        applyVariant(findMatchingVariant(selectedOptionValues()), this.value);
        paintAvailability();
      });
    });

    /* Which combinations exist is true before anything is touched, so the
       first paint happens now rather than after the first tap. */
    paintAvailability();

    /* AJAX add to cart */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = document.getElementById('AddToCartButton');
      var btnText = document.getElementById('AddToCartText');
      var originalText = btnText ? btnText.textContent : '';
      if (btn) btn.disabled = true;
      if (btnText) btnText.textContent = 'Adding...';

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          window.showCartToast(cart, formData.get('id'));
          if (btnText) btnText.textContent = 'Added ✓';
          // "After Add to Cart, do not redirect to /cart" — still true
          // everywhere. The drawer that used to open with it now opens on
          // desktop only; see openCartPanelAfterAdd. Still the same
          // open+refresh pipeline (a real click on the cart icon) when it
          // does, never a separate implementation.
          window.openCartPanelAfterAdd();
          setTimeout(function () {
            if (btnText) btnText.textContent = originalText;
            if (btn) btn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          if (btnText) btnText.textContent = 'Error — try again';
          if (btn) btn.disabled = false;
        });
    });
  }

  /* Buy now -> add then redirect to checkout */
  var buyNowBtn = document.getElementById('BuyNowButton');
  if (buyNowBtn && form) {
    buyNowBtn.addEventListener('click', function () {
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      }).then(function () {
        /* Razorpay Magic Checkout opens on a click on a link to /checkout,
           not on a scripted navigation, so with Magic on the page Buy now
           goes through a real link click. */
        if (document.getElementById('RazorpayMagicCheckoutConfig')) {
          var link = document.querySelector('a.cart-panel-checkout-btn[href="/checkout"]');
          if (!link) {
            link = document.createElement('a');
            link.href = '/checkout';
            link.className = 'cart-panel-checkout-btn';
            link.style.display = 'none';
            document.body.appendChild(link);
          }
          link.click();
          return;
        }
        /* Signed in with their phone: checkout opens with their details
           (assets/vro-checkout-prefill.js). A guest goes as before. */
        if (window.VroCheckout && window.VroCheckout.go) window.VroCheckout.go(window.VroCheckout.url('/checkout')); else window.location.href = '/checkout';
      }).catch(function () {
        /* A failed add must not leave Buy now stuck. */
        buyNowBtn.disabled = false;
      });
    });
  }

  /* ---------------------------------------------------------
     Sticky PDP Add-to-Cart bar — shows once the real .pdp-actions
     buttons scroll out of view, hides again once they're back. Its own
     Add/Buy buttons are pure proxies (a real .click() on the actual
     #AddToCartButton/#BuyNowButton) so there is exactly one add-to-cart
     implementation, not two kept in sync by hand.
  --------------------------------------------------------- */
  var pdpStickyBar = document.getElementById('pdpStickyBar');
  var pdpActions = document.querySelector('.pdp-actions');
  if (pdpStickyBar && pdpActions && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      var actionsVisible = entries[0].isIntersecting;
      pdpStickyBar.hidden = actionsVisible;
      if (!actionsVisible) {
        requestAnimationFrame(function () { pdpStickyBar.classList.add('is-visible'); });
      } else {
        pdpStickyBar.classList.remove('is-visible');
      }
      /* The bar can be shown at a scroll position already past its stop,
         so settle parked/floating now rather than on the next scroll. */
      if (typeof requestStickyPark === 'function') requestStickyPark();
    }, { threshold: 0 });
    stickyObserver.observe(pdpActions);

    /* Where the bar stops. It rides the bottom of the screen through the
       PDP and then parks in the gap after the last block, instead of
       floating on over the "Curated" band and the footer.

       .pdp-container is the end of this product's own page, and on a
       phone the reviews are its last child (snippets/pdp-mobile-order
       moves them there), so its bottom edge is exactly the gap asked
       for. Once that edge rises above the line the bar floats on, the
       bar goes absolute at the foot of the container and scrolls away
       with it.

       Measured off the container rather than the "Curated" section,
       which is a separate section this one cannot see and which a
       merchant can reorder or remove. */
    var pdpStopEl = pdpStickyBar.parentNode;
    var PDP_STICKY_BOTTOM = 96; /* matches .pdp-sticky-bar's bottom */
    var parkTicking = false;

    function updateStickyPark() {
      parkTicking = false;
      if (pdpStickyBar.hidden) return;
      var edge = pdpStopEl.getBoundingClientRect().bottom;
      pdpStickyBar.classList.toggle(
        'is-parked',
        edge <= window.innerHeight - PDP_STICKY_BOTTOM
      );
    }

    function requestStickyPark() {
      if (parkTicking) return;
      parkTicking = true;
      requestAnimationFrame(updateStickyPark);
    }

    window.addEventListener('scroll', requestStickyPark, { passive: true });
    window.addEventListener('resize', requestStickyPark);
    updateStickyPark();

    var stickyAddBtn = document.getElementById('pdpStickyAddBtn');
    var stickyBuyBtn = document.getElementById('pdpStickyBuyBtn');
    var realAddBtn = document.getElementById('AddToCartButton');
    var realBuyBtn = document.getElementById('BuyNowButton');
    if (stickyAddBtn && realAddBtn) {
      stickyAddBtn.addEventListener('click', function () { realAddBtn.click(); });
    }
    if (stickyBuyBtn && realBuyBtn) {
      stickyBuyBtn.addEventListener('click', function () { realBuyBtn.click(); });
    }
  }

  /* ---------------------------------------------------------
     The docked Add-to-bag / Buy-now row on a phone (.pdp--docked-actions:
     the fashion, grooming and health PDPs) stops under Ratings & Reviews
     instead of riding the bottom of the screen the whole way down.

     Ratings & Reviews is the last block of this product's own page on a
     phone — snippets/pdp-mobile-order moves it there, video reviews and
     all — so its bottom edge is the line asked for: the buttons come to
     rest just below the clips and then scroll away with them, rather than
     sitting over the Curated band and the footer, which are not this
     product's to sell.

     `top` is written here rather than left to CSS because the row lives
     inside the add-to-cart <form>, inside the buy column: its offsetParent
     is whatever of those happens to be positioned, and that differs
     between the three PDPs. Measuring the stop in viewport coordinates and
     subtracting the offsetParent's own top is right whichever it is.
  --------------------------------------------------------- */
  var dockRoot = document.querySelector('.pdp--docked-actions');
  var dockBar = dockRoot && dockRoot.querySelector('.pdp-actions');
  if (dockBar) {
    var dockMq = window.matchMedia('(max-width: 575.98px)');
    var dockTicking = false;
    /* Zero, and deliberately. The floating row is 12px of padding then the
       buttons, and the parked one keeps that same 12px — so parking it with
       its top exactly on the reviews' bottom edge lands the buttons on the
       very pixel they were already on, and the handoff is invisible. Any
       gap here is a jump in the page's main call to action, at the one
       moment the shopper is looking at it. */
    var DOCK_PARK_GAP = 0;
    var dockFloatH = 0;      /* the row's height while it is still floating */

    function dockStop() {
      var scope = dockRoot.querySelector('.pdp-container') || dockRoot;
      return scope.querySelector('.pdp-reviews') || scope;
    }

    function updateDock() {
      dockTicking = false;

      /* Above the phone breakpoint the row is an ordinary block in the buy
         column and none of this applies — clear it rather than leave a
         stale `top` behind on a resize. */
      if (!dockMq.matches) {
        dockBar.classList.remove('is-parked');
        dockBar.style.top = '';
        return;
      }

      var stop = dockStop();
      if (!stop) return;

      /* The parked row is shorter than the floating one — it drops the
         clearance it needed for the glass nav. Comparing against whichever
         height it happens to have would put the flip point in two
         different places and flicker between them, so the floating height
         is measured once and used for both. */
      var wasParked = dockBar.classList.contains('is-parked');
      if (!wasParked) dockFloatH = dockBar.offsetHeight;
      var edge = stop.getBoundingClientRect().bottom;
      var park = edge <= window.innerHeight - dockFloatH;

      if (!park) {
        if (wasParked) { dockBar.classList.remove('is-parked'); dockBar.style.top = ''; }
        return;
      }

      if (!wasParked) dockBar.classList.add('is-parked');
      var host = dockBar.offsetParent;
      if (!host) { dockBar.classList.remove('is-parked'); dockBar.style.top = ''; return; }
      dockBar.style.top = (edge - host.getBoundingClientRect().top + DOCK_PARK_GAP) + 'px';
    }

    function requestDock() {
      if (dockTicking) return;
      dockTicking = true;
      requestAnimationFrame(updateDock);
    }

    window.addEventListener('scroll', requestDock, { passive: true });
    window.addEventListener('resize', requestDock);
    if (dockMq.addEventListener) dockMq.addEventListener('change', requestDock);
    else if (dockMq.addListener) dockMq.addListener(requestDock);

    /* The rail below fills in from fetch() and the reviews move on the
       media-query handler, so the stop's position is not final at DOM
       ready. Re-measure as the page settles. */
    window.addEventListener('load', requestDock);
    if ('ResizeObserver' in window) {
      var dockScope = dockRoot.querySelector('.pdp-container') || dockRoot;
      new ResizeObserver(requestDock).observe(dockScope);
    }
    requestDock();
  }

  /* ---------------------------------------------------------
     PDP gallery: click-to-play video/external_video media. The real
     <video>/embed markup for each slide sits inert in a <template> (see
     sections/main-product.liquid) until this swaps it in for the poster
     button — nothing autoplays or even requests the video file until the
     shopper actually asks to play it.
  --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var playBtn = e.target.closest('[data-pdp-play-video]');
    if (!playBtn) return;
    var slide = playBtn.closest('[data-pdp-video-slide]');
    var template = slide && slide.querySelector('[data-pdp-video-embed]');
    if (!template) return;
    playBtn.replaceWith(template.content.cloneNode(true));
  });

  // Pause whatever's playing when the carousel moves to a different slide
  // (native <video> only — external embeds don't expose a reliable cross-
  // origin pause API without their own SDK, so those are left as-is).
  var pdpCarousel = document.getElementById('pdpGalleryCarousel');
  if (pdpCarousel) {
    pdpCarousel.addEventListener('slide.bs.carousel', function () {
      pdpCarousel.querySelectorAll('video').forEach(function (v) { v.pause(); });
    });
  }

  /* Quick-add (+) buttons on feed cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.feed-add-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-add-variant');
    if (!variantId) return;

    var originalHtml = btn.innerHTML;

    /* The tick is drawn on the click, not on the response.

       This used to wait out two round trips before anything moved: POST
       /cart/add.js, then a whole GET /cart.js for the count and the line,
       and only then the tick, the count and the toast. On a normal
       connection that is most of a second in which the only thing on
       screen saying the tap registered is the browser's own "waiting
       for…" in the corner — which is what a loader in the bottom left
       is. The work has not got faster; the feedback no longer waits for
       it.

       So: tick and count immediately, one POST, and the toast from what
       that POST answers with — /cart/add.js returns the line it took, so
       the second fetch was never needed on the critical path. The real
       count is reconciled from /cart.js afterwards, off to the side,
       where being a moment late costs nothing. If the add fails the
       count goes back and the button says so. */
    btn.disabled = true;
    btn.textContent = '✓';

    var countEl = document.querySelector('.cart-count');
    var prevCount = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;
    if (countEl) updateCartCount(prevCount + 1);

    var restore = function () {
      btn.innerHTML = originalHtml;
      btn.disabled = false;
    };

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);

    fetch('/cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        return res.json();
      })
      .then(function (added) {
        /* One item posted, so Shopify answers with the line itself; a
           multi-item add answers with { items: [...] }. Both shapes, since
           this helper is the one every card uses. */
        var line = added && added.items ? added.items[0] : added;
        window.showCartToastForLine(line);
        // Same open+refresh pipeline every other add path uses (real
        // cart-panel-open click) — never a separate/duplicate cart-drawer
        // implementation. Desktop only now; see openCartPanelAfterAdd.
        window.openCartPanelAfterAdd();
        setTimeout(restore, 1200);
        /* The authoritative count, once it does not hold anything up. */
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCartCount(cart.item_count); })
          .catch(function () {});
      })
      .catch(function () {
        if (countEl) updateCartCount(prevCount);
        btn.textContent = '!';
        setTimeout(restore, 1200);
      });
  });

  /* "Add the VRO kit" (sections/vro-kit-bundle.liquid) — a real multi-item
     add-to-cart, several products in one click (items[][id]/items[][
     quantity] hidden inputs, one pair per bundle product). This was a
     plain <form method="post" action="{{ routes.cart_add_url }}">, the
     only add-to-cart path in the theme with no AJAX interception at all
     — a real submit POSTs to Shopify's cart endpoint and gets redirected
     to /cart, instead of staying on the page like every other add path.
     Same fetch('/cart/add.js', { body: new FormData(form) }) pattern as
     everywhere else — Shopify's cart endpoint accepts the exact same
     items[][id]/items[][quantity] field pairs from a FormData body. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.vro-kit-add-form');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('.build-look-add-btn') || form.querySelector('button[type="submit"]');
    var originalHtml = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.style.opacity = '.6'; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        showToast('Added to cart', 'cart');
        window.openCartPanelAfterAdd();
      })
      .catch(function () {
        showToast('Could not add — try again');
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.style.opacity = ''; btn.innerHTML = originalHtml; }
      });
  });

  /* ---------------------------------------------------------
     Header mega menu: open on hover, close on the way out

     custom.css opens a world's panel on :hover alone, so it also closed the
     instant the pointer left — which left nowhere to put a close button,
     because reaching for one took the menu away with it.

     Hover still opens the panel, and leaving still closes it, but not
     instantly: the pointer gets a moment's grace on the way out, which is
     what makes the gap between the tab and the panel crossable and stops
     the menu flickering shut under a hand that is still heading for it.
     Coming back inside during that moment cancels the close, so nothing is
     lost by pausing. A panel can also be closed outright — the × in its
     corner, a click anywhere off it, or Escape — and while the keyboard is
     inside it, leaving with the mouse closes nothing at all.

     Hover-out is a pointer idea, so it applies only where there is a
     pointer: on a phone the panel opens on tap and waits to be dismissed.
     With JS off nothing here runs and the hover rule in custom.css behaves
     exactly as it always did.
  --------------------------------------------------------- */
  (function () {
    var worlds = document.querySelectorAll('.site-world--has-mega');
    if (!worlds.length) return;

    var CLOSE_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"'
      + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<path d="M18 6 6 18M6 6l12 12"/></svg>';

    /* Long enough to cross the gap between a tab and its panel without
       hurrying, short enough that a menu left behind is gone by the time
       the eye returns to the page. */
    var LEAVE_GRACE = 320;
    var leaveTimer = null;

    function cancelLeave() {
      if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
    }

    /* Which device the shopper is driving with, right now.

       This was asked of :focus-visible, which is the browser's own answer
       to "did they get here by keyboard" — and browsers do not all give the
       same one. The location picker already caught Brave and Chrome
       disagreeing about a different feature; betting the menu's only way of
       closing on a pseudo-class whose edge cases differ per engine is the
       same bet, and it is what left the panel open with nothing hovering
       it: one veto, on every close path, that could be true for reasons
       this file cannot see.

       Tracked here instead. A key that moves focus says keyboard; anything
       the pointer does says pointer, and a pointer that has just moved is
       the one case where the panel must close. Nothing engine-specific is
       consulted, so every browser reads it the same way. */
    var keyboardModality = false;
    var KEYS = { Tab: 1, ArrowUp: 1, ArrowDown: 1, ArrowLeft: 1, ArrowRight: 1,
                 Enter: 1, ' ': 1, Escape: 1, Home: 1, End: 1 };
    document.addEventListener('keydown', function (event) {
      if (KEYS[event.key]) keyboardModality = true;
    }, true);
    document.addEventListener('mousemove', function () { keyboardModality = false; }, true);
    document.addEventListener('mousedown', function () { keyboardModality = false; }, true);
    document.addEventListener('touchstart', function () { keyboardModality = false; }, true);

    /* Is the panel being read with the keyboard, as opposed to merely
       holding whatever was last clicked or hovered? Both halves have to be
       true: focus is inside it, and the keyboard is what is driving. */
    function keyboardInside(world) {
      if (!keyboardModality) return false;
      var active = document.activeElement;
      return !!(active && active !== document.body && world.contains(active));
    }

    /* Desktop pointers only, read at the moment of use rather than once at
       load: a window dragged across a breakpoint, or a laptop that gains a
       mouse, gets the right behaviour without a reload. */
    function pointerLed() {
      if (!window.matchMedia) return true;
      return window.matchMedia('(hover: hover) and (min-width: 992px)').matches;
    }

    function close(world) {
      world.classList.remove('site-world--mega-open');
      /* The pointer may still be sitting on the tab, and the :hover rule
         would reopen the panel the instant this finishes. Suppressed until
         the pointer leaves, so the × does not look broken. */
      world.classList.add('site-world--mega-dismissed');
    }

    function closeAll() {
      worlds.forEach(close);
    }

    function open(world) {
      worlds.forEach(function (other) {
        if (other !== world) close(other);
      });
      world.classList.remove('site-world--mega-dismissed');
      world.classList.add('site-world--mega-open');
    }

    worlds.forEach(function (world) {
      var panel = world.querySelector('.site-mega-menu');
      if (!panel) return;

      world.addEventListener('mouseenter', function () {
        cancelLeave();
        open(world);
      });

      world.addEventListener('mouseleave', function () {
        /* Clearing the suppression first, whatever happens next: hovering
           the tab again should reopen a panel that was dismissed with the ×,
           and that is true on a phone too. */
        world.classList.remove('site-world--mega-dismissed');
        if (!pointerLed()) return;

        cancelLeave();
        leaveTimer = setTimeout(function () {
          leaveTimer = null;
          /* Someone is reading it with the keyboard. The mouse wandering off
             is not their cue to lose the menu.

             Keyboard focus, not any focus: this asked whether the panel
             merely contained document.activeElement, and clicking is also a
             way to focus something. So one click on a sidebar category left
             that button focused, and from then on the menu would not close
             on the way out at all — the shopper had to find the x or click
             the page. Which is exactly the state anyone using this menu ends
             up in, since picking a category is what it is for.

             :focus-visible is the browser's own answer to "did they get here
             by keyboard", and it is what the focus ring already follows.
             Wrapped because a browser without it should close the menu
             rather than keep it open forever. */
          if (keyboardInside(world)) return;
          /* No suppression: the pointer is elsewhere, so :hover cannot
             reopen the panel, and coming back to the tab should. */
          world.classList.remove('site-world--mega-open');
        }, LEAVE_GRACE);
      });

      /* One button per panel, built here rather than in the section: without
         this script the panel closes on mouse-out and has no use for it. */
      var inner = panel.querySelector('.site-mega-menu-all-inner') || panel.firstElementChild || panel;
      if (inner && !inner.querySelector('.vro-mega-close')) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vro-mega-close';
        btn.setAttribute('aria-label', 'Close menu');
        btn.innerHTML = CLOSE_ICON;
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          close(world);
        });
        inner.appendChild(btn);
      }
    });

    /* Where the pointer actually is, asked of the document rather than of
       the panel.

       mouseleave on the world is the obvious way to notice someone leaving,
       and it is not a reliable one here. The panel is a wide absolutely
       positioned box that opens under the tabs, and there are several ways
       for a pointer to end up off it without the event arriving: leaving
       through the strip the panel does not cover, a panel that changes size
       under a stationary cursor as its tiles load, a window that loses and
       regains focus. Every one of those leaves the menu open with nothing
       hovering it, which is what people keep reporting.

       So the close is driven by where the pointer is instead of by an event
       that says it moved. Every hover change on the page reports the
       element under the pointer; if that element is not inside the open
       world, the same grace timer starts, and if it is, the timer is
       cancelled. That makes the gap between a tab and its panel crossable
       for the same reason it was before, and it makes leaving unmissable:
       the pointer has to be over something, and anything else is outside.

       mouseleave is kept below. It is the faster of the two when it does
       fire, and they share one timer, so the pair cannot fight. */
    function startLeave(openWorld) {
      if (leaveTimer) return;            /* already on its way out */
      leaveTimer = setTimeout(function () {
        leaveTimer = null;
        if (keyboardInside(openWorld)) return;
        openWorld.classList.remove('site-world--mega-open');
      }, LEAVE_GRACE);
    }

    document.addEventListener('mouseover', function (event) {
      var openWorld = document.querySelector('.site-world--mega-open');
      if (!openWorld) return;
      if (!pointerLed()) return;
      var target = event.target;
      if (target && target.nodeType === 1 && openWorld.contains(target)) {
        cancelLeave();
        return;
      }
      startLeave(openWorld);
    });

    /* The same test on movement rather than on crossing an element.

       mouseover only fires when the element under the pointer changes, and
       there are ways to end up outside without that happening: a panel that
       grows or shrinks under a still cursor as its tiles load, a window
       that regains focus with the pointer already off the menu, a pointer
       that crosses a gap the panel does not paint. Each one leaves the
       panel open over a page nothing is hovering.

       Movement always reports where the pointer is, so it catches all of
       them. It costs one contains() per move, and only while a panel is
       open — the first line returns on every other move on the site. */
    document.addEventListener('mousemove', function (event) {
      var openWorld = document.querySelector('.site-world--mega-open');
      if (!openWorld) return;
      if (!pointerLed()) return;
      var target = event.target;
      if (target && target.nodeType === 1 && openWorld.contains(target)) {
        cancelLeave();
        return;
      }
      startLeave(openWorld);
    });

    /* A pointer that leaves the window entirely reports no element at all,
       so it never reaches the handler above. Closing on the way out of the
       document covers the shopper who goes for a browser tab or a
       bookmark. */
    document.documentElement.addEventListener('mouseleave', function () {
      if (!document.querySelector('.site-world--mega-open')) return;
      if (!pointerLed()) return;
      cancelLeave();
      closeAll();
    });

    /* Anywhere off an open panel. The world's own tab is excluded because it
       is a link: clicking it navigates, and closing the menu first would
       only make the page flicker on the way out. */
    document.addEventListener('click', function (event) {
      var openWorld = document.querySelector('.site-world--mega-open');
      if (!openWorld) return;
      /* A click whose target is not an element — the document itself, a
         text node from a synthesised event — is off every panel, which is
         the case for closing, not against it. */
      var hit = event.target && event.target.closest
        ? event.target.closest('.site-world--has-mega')
        : null;
      if (hit) return;
      cancelLeave();
      closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      if (!document.querySelector('.site-world--mega-open')) return;
      cancelLeave();
      closeAll();
    });
  })();

  /* ---------------------------------------------------------
     Header mega menu: sidebar category -> tile panel
     Each world's menu ships every category's panel in the HTML with the
     first one visible, so the menu is populated before this runs and stays
     populated if it never does. Pointing at a category swaps which panel
     shows; the link itself still navigates on click.
  --------------------------------------------------------- */
  document.querySelectorAll('.site-mega-menu .site-mega-sidebar').forEach(function (sidebar) {
    var menu = sidebar.closest('.site-mega-menu');
    if (!menu) return;

    var show = function (trigger) {
      var key = trigger.getAttribute('data-mega-cat');
      var panel = menu.querySelector('[data-mega-cat-panel="' + key + '"]');
      if (!panel) return;
      menu.querySelectorAll('[data-mega-cat-panel]').forEach(function (p) { p.hidden = p !== panel; });
      sidebar.querySelectorAll('.site-mega-cat').forEach(function (li) {
        li.classList.toggle('is-active', li.contains(trigger));
      });
    };

    sidebar.querySelectorAll('[data-mega-cat]').forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () { show(trigger); });
      trigger.addEventListener('focus', function () { show(trigger); });
    });
  });

  /* ---------------------------------------------------------
     CLP filter bar: pill -> dropdown panel toggle
  --------------------------------------------------------- */
  var filterBar = document.querySelector('.clp-filterbar-bar');
  if (filterBar) {
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-filter-pill]');
      var openPanel = filterBar.querySelector('.clp-filter-panel:not([hidden])');

      if (pill) {
        var key = pill.getAttribute('data-filter-pill');
        var panel = key === 'all'
          ? null
          : filterBar.querySelector('[data-filter-panel="' + key + '"]');

        if (openPanel && openPanel !== panel) openPanel.hidden = true;
        if (panel) {
          var wasHidden = panel.hidden;
          panel.hidden = !panel.hidden;
          pill.setAttribute('aria-expanded', String(!panel.hidden));

          if (wasHidden) {
            // .clp-filter-panel is `position: fixed` (see custom.css for
            // why) — position it here against the pill's real viewport
            // coords, clamped so it can't run off the right/bottom edge.
            var rect = pill.getBoundingClientRect();
            var top = rect.bottom + 8;
            var left = rect.left;
            var maxLeft = window.innerWidth - panel.offsetWidth - 8;
            if (left > maxLeft) left = Math.max(8, maxLeft);
            var maxTop = window.innerHeight - panel.offsetHeight - 8;
            if (top > maxTop) top = Math.max(8, maxTop);
            panel.style.top = top + 'px';
            panel.style.left = left + 'px';
          }
        }
        return;
      }

      if (openPanel && !e.target.closest('.clp-filter-panel')) {
        openPanel.hidden = true;
      }
    });
  }

  /* ---------------------------------------------------------
     CLP active-filter chips: remove a price-range or sort chip
     (neither has a url_to_remove to link to, so this strips just
     that chip's own query param(s) instead of a plain link)
  --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-param]');
    if (!btn) return;
    var params = new URLSearchParams(window.location.search);
    btn.getAttribute('data-remove-params').split(',').forEach(function (name) {
      if (name) params.delete(name);
    });
    var query = params.toString();
    window.location.href = window.location.pathname + (query ? '?' + query : '');
  });

  /* ---------------------------------------------------------
     CLP curation rail: tab switching
  --------------------------------------------------------- */
  document.querySelectorAll('.clp-curation-tabs').forEach(function (tabs) {
    tabs.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-curation-tab]');
      if (!tab) return;
      var wrap = tabs.closest('.clp-curation');
      var id = tab.getAttribute('data-curation-tab');

      wrap.querySelectorAll('[data-curation-tab]').forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
      });
      wrap.querySelectorAll('[data-curation-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-curation-panel') === id);
      });
    });
  });

  /* Sync PDP gallery filmstrip active state */
  var pdpCarousel = document.getElementById('pdpGalleryCarousel');
  if (pdpCarousel) {
    pdpCarousel.addEventListener('slid.bs.carousel', function (e) {
      document.querySelectorAll('.pdp-thumb').forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === e.to);
      });
    });
  }

  /* Body type on the fashion PDP. One tap, kept with the shopper rather
     than with the product: vro-personalization.js holds it beside their
     skin and hair answers, so it is still picked when they come back and
     on whatever they look at next. Tapping the chosen one again clears
     it — a question answered by accident should be answerable back to
     nothing. */
  (function () {
    var card = document.querySelector('[data-pdp-bodytype]');
    if (!card) return;
    /* Once we know their body type, the card has nothing left to tell them:
       it is the shapes this garment suits, under a heading that asks the
       question they have already answered in the size quiz. So it goes,
       the same way that quiz does. Read straight from the profile, which
       is localStorage, so this runs before the card is painted rather than
       after — the load pass is only for the case where
       vro-personalization.js has not defined the profile yet. */
    if (card.hasAttribute('data-bt-once')) {
      var hideAnswered = function () {
        var pr = (window.VroPersonalization && window.VroPersonalization.profile) || null;
        if (pr && pr.getFacet && pr.getFacet('body')) card.hidden = true;
      };
      hideAnswered();
      if (document.readyState !== 'complete') window.addEventListener('load', hideAnswered);
    }

    /* The fashion PDP's card is display-only now: the product's tags decide
       which body types are highlighted (sections/main-product.liquid), so
       it is neither clickable nor repainted from the shopper's profile. */
    if (card.hasAttribute('data-pdp-bodytype-readonly')) return;
    var options = Array.prototype.slice.call(card.querySelectorAll('[data-pdp-bodytype-value]'));
    if (!options.length) return;

    function paint(value) {
      options.forEach(function (o) {
        o.setAttribute('aria-pressed', o.getAttribute('data-pdp-bodytype-value') === value ? 'true' : 'false');
      });
    }

    function profile() {
      return (window.VroPersonalization && window.VroPersonalization.profile) || null;
    }

    /* vro-personalization.js is deferred like this file and may not have
       run yet; it is only read on a click and once at rest, so a short
       wait is enough and a miss costs the highlight, not the choice. */
    function restore() {
      var p = profile();
      if (p && p.getFacet) paint(p.getFacet('body'));
    }
    if (document.readyState === 'complete') restore();
    else window.addEventListener('load', restore);

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        var value = option.getAttribute('data-pdp-bodytype-value');
        var next = option.getAttribute('aria-pressed') === 'true' ? null : value;
        paint(next);
        var p = profile();
        if (p && p.setFacet) p.setFacet('body', next);
      });
    });
  })();

  /* "N other ingredients" on the grooming PDP's substance table. The rows
     past the first few ship hidden, so a product with twenty ingredients
     shows the ones worth naming and keeps the rest one tap away rather
     than off the page entirely. Delegated: the table is server-rendered
     and there is at most one per page, but this costs nothing either
     way. */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-pdp-spec-toggle]');
    if (!toggle) return;
    var table = toggle.closest('.pdp-spec');
    if (!table) return;
    var open = toggle.getAttribute('aria-expanded') === 'true';
    table.querySelectorAll('[data-pdp-spec-extra]').forEach(function (row) { row.hidden = open; });
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    var label = toggle.querySelector('[data-pdp-spec-more-label]');
    if (label) {
      label.textContent = open ? label.getAttribute('data-more-label') : label.getAttribute('data-less-label');
    }
  });

  /* Product details accordion (snippets/pdp-spec-accordion.liquid). One
     group open at a time, the way the reference behaves; the panel's own
     grid rows do the movement, this only flips the state. Delegated, so a
     section re-rendered by the editor is covered without rewiring. */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-pdp-acc-toggle]');
    if (!toggle) return;
    var group = toggle.closest('.pdp-acc-group');
    var acc = toggle.closest('.pdp-acc');
    if (!group || !acc) return;
    var wasOpen = group.classList.contains('is-open');
    acc.querySelectorAll('.pdp-acc-group.is-open').forEach(function (g) {
      g.classList.remove('is-open');
      var t = g.querySelector('[data-pdp-acc-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) {
      group.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
  });

  /* ---------------------------------------------------------
     PDP "Rate this product?" stars.

     The stars open Judge.me's review form and carry the score the
     shopper picked into it, so the rating they give here is the rating
     the form starts on and the review they write is a real one. It used
     to paint itself and say "Thanks for rating!" while sending nothing
     anywhere, which told people their rating had been recorded when it
     had not. (That message never even appeared: .pdp-rate-prompt has a
     style but no markup.)

     Judge.me's widget is hydrated by their script after the page loads,
     so the form's own stars are not in the DOM when this runs. The
     rating is applied by polling briefly for them after the form opens,
     and every step is optional: no widget on the page, or a Judge.me
     markup change, leaves the stars painting as before rather than
     throwing.
  --------------------------------------------------------- */
  function vroJudgeMeWidget() {
    return document.querySelector('#judgeme_product_reviews, .jdgm-rev-widg');
  }

  /* Judge.me titles its block "Customer Reviews"; the page calls it
     "Review and Rating". The app's own Text settings can do this, but
     doing it here keeps the wording with the rest of the page's copy and
     survives a settings reset. The title is drawn by Judge.me's script
     after load, so this watches for it rather than running once, and
     stops as soon as it has renamed it. */
  (function renameJudgeMeTitle() {
    var WANTED = 'Review and Rating';
    var tries = 0;

    function apply() {
      var titles = document.querySelectorAll('#judgeme_product_reviews .jdgm-rev-widg__title');
      var done = false;
      Array.prototype.forEach.call(titles, function (el) {
        if (el.textContent.trim() !== WANTED) el.textContent = WANTED;
        done = true;
      });
      return done;
    }

    if (apply()) return;
    var timer = setInterval(function () {
      tries += 1;
      if (apply() || tries > 40) clearInterval(timer);
    }, 150);
  })();

  /* Judge.me's form stars, once their script has drawn them. */
  function vroJudgeMeFormStars(widget) {
    var form = widget.querySelector('.jdgm-form');
    if (!form) return [];
    var stars = form.querySelectorAll('.jdgm-form__rating .jdgm-star, .jdgm-star');
    return Array.prototype.slice.call(stars);
  }

  function vroOpenJudgeMeForm(rating) {
    var widget = vroJudgeMeWidget();
    if (!widget) return false;

    var writeLink = widget.querySelector('.jdgm-write-rev-link');
    if (writeLink) writeLink.click();
    widget.scrollIntoView({ behavior: 'smooth', block: 'center' });

    /* The form is drawn asynchronously; give it ~2s to appear. */
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      var stars = vroJudgeMeFormStars(widget);
      if (stars.length >= rating) {
        clearInterval(timer);
        try { stars[rating - 1].click(); } catch (e) { /* form markup changed */ }
      } else if (tries > 20) {
        clearInterval(timer);
      }
    }, 100);

    return true;
  }

  document.querySelectorAll('.pdp-rate-stars').forEach(function (group) {
    /* Without the widget there is nowhere for a rating to go, so the
       prompt is taken off the page rather than left looking clickable. */
    if (!vroJudgeMeWidget()) {
      var row = group.closest('.pdp-rate-row');
      if (row) row.style.display = 'none';
      return;
    }

    var stars = Array.prototype.slice.call(group.querySelectorAll('[data-rate-star]'));
    var locked = 0;

    function paint(count) {
      stars.forEach(function (star, i) {
        var filled = i < count;
        star.querySelector('svg').setAttribute('fill', filled ? '#F5A623' : '#EBE8E2');
        star.querySelector('svg').setAttribute('stroke', filled ? '#F5A623' : '#A8A296');
      });
    }

    stars.forEach(function (star, i) {
      star.addEventListener('mouseenter', function () { paint(i + 1); });
      star.addEventListener('click', function () {
        locked = i + 1;
        paint(locked);
        vroOpenJudgeMeForm(locked);
      });
    });
    group.addEventListener('mouseleave', function () { paint(locked); });
  });

  /* Detect current location on click, reverse-geocoded via the Google
     Geocoding API (needs settings.google_maps_api_key, browser-key +
     HTTP-referrer restricted in Google Cloud Console — see theme settings
     "Location detection"). Checks the Permissions API first so an already
     granted/denied permission doesn't need to re-prompt or gets a clearer
     message instead of silently failing. Result cached in localStorage for
     a day. There can be two buttons on the page at once (desktop header +
     mobile top bar) — they all stay in sync off the same cache. */
  var locationBtns = document.querySelectorAll('.site-location');
  if (locationBtns.length) {
    var LOCATION_CACHE_KEY = 'vro_detected_location';
    var LOCATION_CACHE_MS = 24 * 60 * 60 * 1000;

    function allLocationTexts() {
      return document.querySelectorAll('.site-location-text');
    }

    function allLocationSubtexts() {
      return document.querySelectorAll('.site-location-subtext');
    }

    // A geolocation-detected or cached city is a single line — clear any
    // full-address subtext a logged-in customer's default address may have
    // server-rendered, so the two never end up mismatched (e.g. "Powai
    // Mumbai" as the main line with a stale saved-address line underneath).
    /* The header names a city, never an address. Everything upstream now
       resolves to a bare city, but two things still arrive with a state
       attached: an entry cached before that was true — kept forever by
       design, so a shopper who once resolved "Jaipur, Rajasthan" keeps
       reading it — and a saved address in the picker, whose name is
       whatever the customer typed. Trimming here rather than at each of
       those sources is what makes the cached ones heal: this is the one
       place a label becomes visible, so a label cannot reach the header
       without passing through it.

       The first segment only. Indian geocoders put the city first and the
       state after it, and a name with no comma is already a city and is
       returned untouched. The subtext is deliberately not trimmed: that
       line is an address and is meant to read as one. */
    function cityOnly(label) {
      if (typeof label !== 'string') return label;
      var comma = label.indexOf(',');
      if (comma === -1) return label;
      var head = label.slice(0, comma).trim();
      return head || label;
    }

    function setAllLocationText(label, subtext) {
      var shown = cityOnly(label);
      /* One space between words and none at either end, whatever source
         the line came from: a stray run of spaces or a non-breaking one
         is invisible, but it still widens the line and pushes the arrow. */
      subtext = String(subtext || '').replace(/[\s\u00a0]+/g, ' ').trim();
      allLocationTexts().forEach(function (el) { el.textContent = shown; });
      allLocationSubtexts().forEach(function (el) {
        if (subtext) {
          el.textContent = subtext;
          el.hidden = false;
        } else {
          el.textContent = '';
          el.hidden = true;
        }
      });
    }

    /* Set while a detection is running, so a silent one started on our own
       initiative never fires alongside another. Every path out of a
       detection — resolved, geocoder down, refused, timed out — ends in
       stopLocating(), so this is cleared wherever the request ends. */
    var detectInFlight = false;

    function stopLocating() {
      detectInFlight = false;
      locationBtns.forEach(function (btn) { btn.classList.remove('is-locating'); });
    }

    var cached = null;
    try { cached = JSON.parse(localStorage.getItem(LOCATION_CACHE_KEY) || 'null'); } catch (e) { cached = null; }
    /* The last city we resolved is shown however old it is. Expiring it here
       put the theme's fallback city back in the header while
       assets/vro-weather.js — which reads this same entry and never expired
       it — carried on naming the real one in the hover card, so the two
       openly disagreed: "Mumbai" under the logo, the shopper's own city in
       the card hanging off it. A stale city is refreshed below rather than
       replaced by a city the shopper has nothing to do with. */
    if (cached && cached.label) setAllLocationText(cached.label, cached.subtext);

    function resetLocationText(defaultText) {
      var anyLocating = Array.prototype.some.call(allLocationTexts(), function (el) {
        return el.textContent === 'Locating…';
      });
      if (anyLocating) return;

      var cachedNow = null;
      try { cachedNow = JSON.parse(localStorage.getItem(LOCATION_CACHE_KEY) || 'null'); } catch (e) { cachedNow = null; }
      // Same rule as the load-time read above: the last city we resolved is
      // shown however old it is. Expiring it here would put the theme's
      // fallback city back on the pill while the weather card, reading the
      // same entry, still named the real one. refreshStaleLocation() is what
      // deals with age.
      setAllLocationText((cachedNow && cachedNow.label) || defaultText, cachedNow && cachedNow.subtext);
    }

    // Picks the first address component matching any of `wantedTypes`, in
    // priority order. `getName` normalizes the field name difference between
    // the classic Geocoding API (`long_name`) and the Places API New
    // (`longText`), so both reverse-geocode and place-details results can
    // share this same extraction logic.
    function pickComponent(components, wantedTypes, getName) {
      for (var i = 0; i < wantedTypes.length; i++) {
        for (var j = 0; j < components.length; j++) {
          if (components[j].types.indexOf(wantedTypes[i]) !== -1) return getName(components[j]);
        }
      }
      return null;
    }

    // Splits a geocoded address into "City, State" (main line) + the finer
    // area (subtext). The header names where the shopper is, and that is
    // what a city and a state say — a neighbourhood on its own ("Malviya
    // Nagar") reads as an address, and it is standing in for a city name.
    // `city` comes back on its own as well, for the places that want the
    // city and not the sentence: the weather card and the rail heading,
    // which read better as "Jaipur" than "Jaipur, Rajasthan".
    //
    // A geocode that named an area and nothing above it still gives the
    // area — a name we have beats no name at all.
    function areaCityState(components, getName) {
      var area = pickComponent(components, ['sublocality_level_1', 'sublocality', 'sublocality_level_2', 'neighborhood'], getName);
      var city = pickComponent(components, ['locality', 'postal_town', 'administrative_area_level_2'], getName);
      var state = pickComponent(components, ['administrative_area_level_1'], getName);

      /* The city alone. "Jaipur, Rajasthan" reads as an address rather
         than as a place, and the state earns nothing next to a city name
         a shopper already knows they are in. `state` is still picked
         above because the geocoders are asked for it either way and a
         caller below may want it; it simply stops reaching the header. */
      var main = city || area || '';
      var sub = (area && area !== city && main !== area) ? area : '';
      return { main: main, sub: sub, city: city || area || '' };
    }

    /* Everything that has to happen once a position has a name: the two
       header buttons, the cache, and whoever is listening (the weather
       rail). Split out because the name can come from either geocoder. */
    /* `extra` (optional): { pincode, approximate }. The pincode is kept in
       the cache and on the event so anything that checks delivery later has
       the number the shopper typed or the geocoder found; `approximate`
       marks a city read from the network (IP) rather than the device, so
       the picker can stay open and ask for the pincode instead. */
    function applyResolved(label, sub, lat, lon, city, extra) {
      extra = extra || {};
      setAllLocationText(label, sub);
      try {
        // lat/lon ride along so anything else that needs the shopper's
        // position (assets/vro-weather.js) can use it without asking for
        // permission a second time. `city` rides along for the same reason
        // — so the weather card can name the city without re-deriving it
        // from a label that also carries the state. Older cache entries
        // simply lack them.
        localStorage.setItem(LOCATION_CACHE_KEY, JSON.stringify({
          label: label, subtext: sub, city: city || '', lat: lat, lon: lon,
          pincode: extra.pincode || '', approximate: !!extra.approximate, savedAt: Date.now()
        }));
      } catch (e) { /* storage unavailable, ignore */ }
      document.dispatchEvent(new CustomEvent('vro:location-changed', {
        detail: {
          label: label, subtext: sub, city: city || '', lat: lat, lon: lon,
          pincode: extra.pincode || '', approximate: !!extra.approximate
        }
      }));
    }

    /* ---- Keyless lookups ------------------------------------------------
       The Google key in theme settings is referrer-restricted, and Google
       refuses such a key for the Geocoding web service outright
       ("API keys with referer restrictions cannot be used with this API")
       and, on yourvro.com, for Places too (API_KEY_HTTP_REFERRER_BLOCKED).
       So every path below has a keyless source that works on its own:
         - pincode  → India Post (api.postalpincode.in): area, district, state
         - pincode  → OpenStreetMap Nominatim, for coordinates only
         - text     → Photon (photon.komoot.io), OSM-backed autocomplete
         - position → BigDataCloud client reverse geocode (then Nominatim)
         - no GPS   → BigDataCloud with no coordinates = IP-level city
       All four answer with Access-Control-Allow-Origin: *. */
    function fetchJSON(url, timeoutMs) {
      var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, timeoutMs || 8000) : null;
      return fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (res) {
          if (timer) clearTimeout(timer);
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        }, function (err) {
          if (timer) clearTimeout(timer);
          throw err;
        });
    }

    /* "Jaipur Municipal Corporation" → "Jaipur", "Bengaluru Urban District"
       → "Bengaluru Urban". OSM and India Post name the civic body or the
       district; the header wants the city a shopper would say. */
    function cleanCityName(name) {
      if (!name || typeof name !== 'string') return '';
      return name
        .replace(/\s+(Municipal Corporation|Municipal Council|Nagar Nigam|Nagar Palika|Cantonment Board|Tehsil|Taluka|District|Division)$/i, '')
        .trim();
    }

    // Title-case India Post's "S.F.S.Mansarovar" / "Powai Iit" style names
    // only where they came in all-caps; mixed case is left as sent.
    function tidyArea(name) {
      if (!name) return '';
      if (name === name.toUpperCase()) {
        return name.toLowerCase().replace(/\b[a-z]/g, function (c) { return c.toUpperCase(); });
      }
      return name;
    }

    var PINCODE_RE = /^[1-9][0-9]{5}$/;

    function lookupPincode(pin) {
      return fetchJSON('https://api.postalpincode.in/pincode/' + pin, 7000).then(function (data) {
        var entry = data && data[0];
        var offices = (entry && entry.Status === 'Success' && entry.PostOffice) || [];
        if (!offices.length) return null;
        var delivering = offices.filter(function (o) { return o.DeliveryStatus === 'Delivery'; });
        var list = (delivering.length ? delivering : offices).map(function (o) {
          return { area: tidyArea(o.Name), city: cleanCityName(o.District) || cleanCityName(o.Block), state: o.State || '' };
        });
        return { pincode: pin, city: list[0].city, state: list[0].state, areas: list };
      });
    }

    function lookupPincodeOSM(pin) {
      return fetchJSON('https://nominatim.openstreetmap.org/search?postalcode=' + pin +
        '&country=in&format=json&addressdetails=1&limit=1&accept-language=en', 7000).then(function (rows) {
        var r = rows && rows[0];
        if (!r) return null;
        var a = r.address || {};
        return {
          lat: parseFloat(r.lat), lon: parseFloat(r.lon),
          city: cleanCityName(a.city || a.town || a.state_district || a.county || ''),
          area: a.suburb || a.neighbourhood || '',
          state: a.state || ''
        };
      });
    }

    function nominatimReverse(lat, lon) {
      return fetchJSON('https://nominatim.openstreetmap.org/reverse?lat=' + lat + '&lon=' + lon +
        '&format=jsonv2&addressdetails=1&zoom=16&accept-language=en', 7000).then(function (d) {
        var a = (d && d.address) || {};
        var city = cleanCityName(a.city || a.town || a.village || a.state_district || a.county || '');
        if (!city) return null;
        return { city: city, area: a.suburb || a.neighbourhood || a.city_district || '', pincode: a.postcode || '' };
      });
    }

    /* "Locating…", "Location blocked" and friends answer a shopper who just
       pressed something. A detection they did not ask for — the one this
       page runs on a first visit, or on a refresh where the permission is
       already granted — says nothing at all: it either produces a better
       city or leaves the header exactly as it was. That is the whole of
       the flicker people saw on refresh, where a city they already had was
       replaced by an error for a couple of seconds on its way back to the
       same answer. */
    function showStatus(message, defaultText, silent) {
      if (silent) return;
      setAllLocationText(message);
      setTimeout(function () { resetLocationText(defaultText); }, 2500);
    }

    /* Detection ended with no position: refused, unsupported, or the
       request timed out. Announced so a listener can tell that apart from
       a browser that never put anything in front of the shopper — the two
       look identical from the outside, and only one of them is worth
       following up. */
    function announceNoPosition(reason) {
      document.dispatchEvent(new CustomEvent('vro:location-failed', {
        detail: { reason: reason }
      }));
    }

    /* Naming the position failed, but the position itself is good — and a
       position is all the weather rail needs. Keep it, so a geocoder being
       down costs the shopper a city label and nothing else. Any label
       already on screen (a saved address, a previous detection) is kept as
       it was rather than replaced with an error that outlives the request. */
    function keepPositionOnly(lat, lon, defaultText, silent) {
      var prev = null;
      try { prev = JSON.parse(localStorage.getItem(LOCATION_CACHE_KEY) || 'null'); } catch (e) { prev = null; }
      var label = (prev && prev.label) || '';
      var sub = (prev && prev.subtext) || '';
      var city = (prev && prev.city) || '';
      try {
        localStorage.setItem(LOCATION_CACHE_KEY, JSON.stringify({
          label: label, subtext: sub, city: city, lat: lat, lon: lon, savedAt: Date.now()
        }));
      } catch (e) { /* storage unavailable, ignore */ }
      /* Set directly rather than through resetLocationText, which refuses to
         act while a button still reads "Locating…" — which is exactly the
         state we are in here. Nothing to undo when the request was silent:
         the header was never touched. */
      if (!silent) setAllLocationText(label || defaultText || '', sub);
      document.dispatchEvent(new CustomEvent('vro:location-changed', {
        detail: { label: label, subtext: sub, city: city, lat: lat, lon: lon }
      }));
    }

    /* Second try, when Google is not an option: BigDataCloud's client-side
       reverse geocoder. No key and no account, so it works even when the
       Google key is missing, restricted to other APIs, or out of quota —
       which is what put "Location unavailable" in the header. It is
       city-level only, so Google stays the first choice for the
       neighbourhood-level line the "deliver to" panel shows. */
    function reverseGeocodeKeyless(lat, lon, defaultText, silent) {
      var url = 'https://api.bigdatacloud.net/data/reverse-geocode-client?latitude='
        + lat + '&longitude=' + lon + '&localityLanguage=en';

      fetchJSON(url, 8000)
        .then(function (data) {
          /* Same shape as the Google path: the city leads, the finer
             locality goes underneath. BigDataCloud's `locality` is the
             suburb ("Malviya Nagar") and its `city` the city ("Jaipur").

             Except where it isn't: for most of south Jaipur it answers
             city "Sanganer" — the tehsil — which is not the city anyone
             there would name. Its own admin list still carries the civic
             body ("Jaipur Municipal Corporation"), and where one is listed
             that is the city. */
          var city = data.city || data.locality;
          var admin = (data.localityInfo && data.localityInfo.administrative) || [];
          for (var ai = 0; ai < admin.length; ai++) {
            var an = admin[ai] && admin[ai].name;
            if (an && /\s(Municipal Corporation|Nagar Nigam)$/i.test(an)) { city = cleanCityName(an); break; }
          }

          /* The city alone, the same answer areaCityState gives on the
             Google path. This used to join the state on after a comma, and
             that is the whole of why the header read differently in two
             browsers: Brave blocks Google's geocoder, so it falls through to
             here, while Chrome never gets this far. The label was trimmed
             for display either way, but a source that hands back an address
             and a display that cuts it down is one refresh away from
             disagreeing again — better that both paths mean the same thing
             by the time they hand a name over.

             principalSubdivision is not read at all now. It was only ever
             here to be appended, and nothing else wanted it. */
          var main = city;
          if (!main) throw new Error('No location found');
          var area = (data.locality && data.locality !== city) ? data.locality : '';
          var pin = PINCODE_RE.test(String(data.postcode || '')) ? String(data.postcode) : '';
          applyResolved(main, area, lat, lon, city, { pincode: pin });
        })
        .catch(function () {
          /* BigDataCloud down or blocked (some ad blockers list it): try
             OpenStreetMap before settling for a position with no name. */
          return nominatimReverse(lat, lon).then(function (r) {
            if (!r) throw new Error('No location found');
            applyResolved(r.city, r.area && r.area !== r.city ? r.area : '', lat, lon, r.city, { pincode: PINCODE_RE.test(r.pincode) ? r.pincode : '' });
          });
        })
        .catch(function () { keepPositionOnly(lat, lon, defaultText, silent); })
        /* Not .finally(): it landed in Safari a year after fetch did, and
           calling it where it does not exist throws rather than degrades. */
        .then(stopLocating, stopLocating);
    }

    /* The device would not give a position (no GPS fix, no Wi-Fi location,
       the request timed out) — but the shopper did press the button and did
       not refuse. BigDataCloud called with no coordinates answers with the
       city of the shopper's network. It is city-level and can be wrong on
       mobile data, so it is marked approximate and the picker says so and
       asks for the pincode rather than closing on it. */
    function ipFallback(defaultText, reason) {
      fetchJSON('https://api.bigdatacloud.net/data/reverse-geocode-client?localityLanguage=en', 8000)
        .then(function (data) {
          if (!data || data.countryCode !== 'IN') throw new Error('Not in India');
          var city = data.city || data.locality;
          if (!city) throw new Error('No city');
          applyResolved(city, '', data.latitude, data.longitude, city, { approximate: true });
        })
        .catch(function () {
          showStatus('Location unavailable', defaultText, false);
          announceNoPosition(reason || 'unavailable');
        })
        .then(stopLocating, stopLocating);
    }

    function reverseGeocode(lat, lon, googleMapsKey, defaultText, silent) {
      /* Straight to the keyless geocoder. Google's Geocoding web service
         does not accept a referrer-restricted key at all — and a browser key
         must be referrer-restricted — so the Google request below could only
         ever come back REQUEST_DENIED, costing every detection a wasted round
         trip before the fallback ran. It stays behind the explicit opt-in
         data-google-geocode="true" for a server-style key. */
      var geocodeOptIn = locationBtns[0] && locationBtns[0].getAttribute('data-google-geocode') === 'true';
      if (!googleMapsKey || !geocodeOptIn) {
        reverseGeocodeKeyless(lat, lon, defaultText, silent);
        return;
      }

      var url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lon + '&key=' + encodeURIComponent(googleMapsKey);

      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('Reverse geocode failed');
          return res.json();
        })
        .then(function (data) {
          if (data.status !== 'OK' || !data.results || !data.results.length) {
            throw new Error(data.status || 'No location found');
          }

          var components = data.results[0].address_components || [];
          var parsed = areaCityState(components, function (c) { return c.long_name; });
          var label = parsed.main || data.results[0].formatted_address;
          if (!label) throw new Error('No location found');

          applyResolved(label, parsed.sub, lat, lon, parsed.city);
          stopLocating();
        })
        .catch(function () {
          /* REQUEST_DENIED (key restricted to other APIs, referrer not
             allowed), OVER_QUERY_LIMIT, billing off, network — all of it
             lands here, and none of it should cost the shopper their city. */
          reverseGeocodeKeyless(lat, lon, defaultText, silent);
        });
    }

    function requestLocation(googleMapsKey, defaultText, silent) {
      /* Checked again here, and not only in detectLocation: both callers of
         a silent detection get there through an async permission query, so
         this is the first point at which the two cannot interleave. */
      if (silent && detectInFlight) return;
      detectInFlight = true;
      if (!silent) {
        locationBtns.forEach(function (btn) { btn.classList.add('is-locating'); });
        showStatus('Locating…', defaultText, false);
      }

      navigator.geolocation.getCurrentPosition(
        function (position) {
          reverseGeocode(position.coords.latitude, position.coords.longitude, googleMapsKey, defaultText, silent);
        },
        function (err) {
          var denied = err && err.code === 1;
          /* Refused is refused: say so and leave it. But "unavailable" and
             "timed out" are the device failing, not the shopper — that is
             the "works sometimes" (desktops with no Wi-Fi location, phones
             indoors with no fix). A pressed button then falls back to the
             network's city instead of ending in an error. */
          if (!denied && !silent) {
            ipFallback(defaultText, err && err.code === 3 ? 'timeout' : 'unavailable');
            return;
          }
          stopLocating();
          showStatus(denied ? 'Location blocked' : 'Location unavailable', defaultText, silent);
          announceNoPosition(denied ? 'denied' : 'unavailable');
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: LOCATION_CACHE_MS }
      );
    }

    function detectLocation(locationBtn, silent) {
      /* Two silent detections for one position buy the shopper nothing but
         a second reverse-geocode request — the weather section asks on a
         first load, the refresh below asks when the cached city has gone
         stale. A detection the shopper actually pressed always goes
         through, whatever else is in flight. */
      if (silent && detectInFlight) return;

      var googleMapsKey = locationBtn.getAttribute('data-google-maps-key') || '';
      var defaultText = locationBtn.getAttribute('data-default-text');

      if (!navigator.geolocation) {
        showStatus('Location unavailable', defaultText, silent);
        announceNoPosition('unsupported');
        return;
      }

      // Check the permission first, where the browser will tell us:
      // 'granted' skips straight to a fetch (no re-prompt) and 'denied'
      // gets a clear message instead of a request that silently fails.
      //
      // Only Chromium and Firefox answer for geolocation. Safari has
      // navigator.permissions but not this query, and older versions THROW
      // rather than reject — which used to take the whole function down
      // with it, so Safari never got as far as asking. Anything other than
      // a usable answer now falls through to getCurrentPosition, which
      // prompts natively on every browser.
      var query = null;
      try {
        if (navigator.permissions && navigator.permissions.query) {
          query = navigator.permissions.query({ name: 'geolocation' });
        }
      } catch (e) { query = null; }

      if (!query || typeof query.then !== 'function') {
        requestLocation(googleMapsKey, defaultText, silent);
        return;
      }

      query
        .then(function (status) {
          if (status && status.state === 'denied') {
            showStatus('Enable location in browser settings', defaultText, silent);
            announceNoPosition('denied');
            return;
          }
          requestLocation(googleMapsKey, defaultText, silent);
        })
        .catch(function () { requestLocation(googleMapsKey, defaultText, silent); });
    }

    /* Reuse this detection (permission check, Google reverse geocode,
       cache, vro:location-changed) from elsewhere rather than duplicating
       any of it — assets/vro-weather.js calls detect() on a first-time
       visitor. Returns false when there is no location control on the page
       to read the API key from. */
    window.VroLocation = {
      /* opts.silent: run without touching the header. Pass it for anything
         the shopper did not just click — a detection they did not ask for
         has no business replacing the city in front of them with
         "Locating…" and then "Location blocked" on its way to the same
         answer. */
      detect: function (opts) {
        if (!locationBtns.length) return false;
        detectLocation(locationBtns[0], !!(opts && opts.silent));
        return true;
      }
    };

    // A location control opens the "deliver to" panel beside it rather than
    // detecting outright; detection is what the panel's own "Use my current
    // location" button does. The hero's control has a panel of its own now,
    // so a phone gets the same choices a desktop does — search, a saved
    // address, add a new one — instead of having its city guessed at on tap.
    // The fallback below is what a control with no panel beside it does, and
    // is left in place for one added somewhere new.
    locationBtns.forEach(function (locationBtn) {
      var picker = locationBtn.parentElement && locationBtn.parentElement.querySelector('.site-location-picker');
      if (!picker) {
        locationBtn.addEventListener('click', function () { detectLocation(locationBtn); });
        return;
      }

      locationBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = picker.classList.toggle('is-open');
        locationBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      /* "Use my current location", with the outcome kept in front of the
         shopper.

         It used to fire the detection and close the panel in the same
         breath. Everything the detection has to say then went onto the
         header button, behind the panel that had just shut — so a refused
         permission, a browser with location switched off and a request
         that simply timed out were indistinguishable from the button
         doing nothing at all, which is exactly what it looked like.

         The panel stays open until there is an answer. Success closes it,
         because the answer is then the city in the header. A failure says
         which failure it was, under the button that was pressed. The
         timeout is a backstop for the case the detection reports neither:
         some browsers neither resolve nor reject getCurrentPosition when
         the prompt is dismissed rather than answered. */
      var currentLocationBtn = picker.querySelector('.site-location-current');
      if (currentLocationBtn) {
        var locateNote = picker.querySelector('.site-location-note');
        var locateTimer = null;
        var locateBusy = false;

        var LOCATE_MESSAGES = {
          denied: 'Location is blocked for this site. Allow it in your browser’s site settings, or just type your pincode above.',
          unavailable: 'Couldn’t get your location. Type your pincode above instead.',
          unsupported: 'This browser can’t share your location. Type your pincode above instead.',
          timeout: 'That took too long. Type your pincode above, or try again.'
        };

        function setNote(text) {
          if (!locateNote) return;
          locateNote.textContent = text || '';
          locateNote.hidden = !text;
        }

        function endLocating() {
          locateBusy = false;
          if (locateTimer) { clearTimeout(locateTimer); locateTimer = null; }
          currentLocationBtn.classList.remove('is-locating');
          currentLocationBtn.disabled = false;
          document.removeEventListener('vro:location-changed', onLocated);
          document.removeEventListener('vro:location-failed', onLocateFailed);
        }

        /* A position without a name is not an answer.

           keepPositionOnly() fires this same event when the geocoders are
           unreachable — the position is good and worth keeping for the
           weather rail, but there is no city to put in the header, and the
           label it carries is whatever was cached before, which on a first
           visit is nothing at all. Closing the panel on that is the one
           way this button can still look like it did nothing: the shopper
           presses it, the panel shuts, and the header says exactly what it
           said before. So the panel stays open and says what happened. */
        function onLocated(e) {
          var label = e && e.detail && e.detail.label;
          endLocating();
          if (!label) {
            setNote('Found your position, but couldn’t name the area. Type your pincode above instead.');
            return;
          }
          /* A city read from the network, not the device: shown in the
             header, but the panel stays open and asks for the pincode,
             because that city can be the ISP's and not the shopper's. */
          if (e.detail.approximate) {
            setNote('Showing ' + cityOnly(label) + ' from your network — type your pincode above for your exact area.');
            var pinInput = picker.querySelector('.site-location-search-input');
            if (pinInput) { try { pinInput.focus({ preventScroll: true }); } catch (err) { pinInput.focus(); } }
            return;
          }
          setNote('');
          picker.classList.remove('is-open');
          locationBtn.setAttribute('aria-expanded', 'false');
        }

        function onLocateFailed(e) {
          var reason = (e && e.detail && e.detail.reason) || 'unavailable';
          endLocating();
          setNote(LOCATE_MESSAGES[reason] || LOCATE_MESSAGES.unavailable);
        }

        currentLocationBtn.addEventListener('click', function () {
          if (locateBusy) return;
          locateBusy = true;
          setNote('');
          currentLocationBtn.classList.add('is-locating');
          currentLocationBtn.disabled = true;
          document.addEventListener('vro:location-changed', onLocated);
          document.addEventListener('vro:location-failed', onLocateFailed);
          locateTimer = setTimeout(function () {
            endLocating();
            setNote(LOCATE_MESSAGES.timeout);
          }, 20000);
          detectLocation(locationBtn);
        });
      }

      picker.querySelectorAll('.site-location-address').forEach(function (label) {
        label.addEventListener('click', function () {
          picker.querySelectorAll('.site-location-address').forEach(function (l) { l.classList.remove('is-selected'); });
          label.classList.add('is-selected');
          var name = label.querySelector('.site-location-address-name');
          var line = label.querySelector('.site-location-address-line');
          if (name) setAllLocationText(name.textContent, line ? line.textContent : '');
          try {
            localStorage.setItem(LOCATION_CACHE_KEY, JSON.stringify({
              label: name ? name.textContent : '',
              subtext: line ? line.textContent : '',
              savedAt: Date.now()
            }));
          } catch (e) { /* storage unavailable, ignore */ }
          picker.classList.remove('is-open');
          locationBtn.setAttribute('aria-expanded', 'false');
        });
      });

      // Address search: Places API (New) autocomplete-as-you-type, then a
      // details lookup on pick to resolve the same area/city/state shape
      // used everywhere else in the picker. Uses `places.googleapis.com`
      // (not the classic `maps.googleapis.com/maps/api/place/...` endpoint)
      // because the New API supports CORS for a browser-restricted key —
      // the classic Places endpoints don't, and would silently fail here.
      var searchInput = picker.querySelector('.site-location-search-input');
      var suggestionsList = picker.querySelector('.site-location-suggestions');
      if (searchInput && suggestionsList) {
        var searchGoogleMapsKey = locationBtn.getAttribute('data-google-maps-key') || '';
        var searchDebounce = null;
        var searchSeq = 0;

        /* The input says it is a combobox, so it has to say whether its
           list is open — that is the half of the contract that tells a
           screen reader, and the browser, that the suggestions under this
           field are ours. Routed through one pair of helpers so the flag
           cannot drift from the list's own hidden state. */
        function openSuggestions() {
          suggestionsList.hidden = false;
          searchInput.setAttribute('aria-expanded', 'true');
        }

        function closeSuggestions() {
          suggestionsList.hidden = true;
          suggestionsList.innerHTML = '';
          searchInput.setAttribute('aria-expanded', 'false');
        }

        function renderSuggestionsMessage(text) {
          suggestionsList.innerHTML = '';
          var li = document.createElement('li');
          li.className = 'site-location-suggestion-empty';
          li.textContent = text;
          suggestionsList.appendChild(li);
          openSuggestions();
        }

        function selectSuggestion(placeId, fallbackLabel) {
          if (!searchGoogleMapsKey) return;
          renderSuggestionsMessage('Loading address…');

          fetch('https://places.googleapis.com/v1/places/' + placeId, {
            headers: {
              'X-Goog-Api-Key': searchGoogleMapsKey,
              'X-Goog-FieldMask': 'addressComponents,formattedAddress,location'
            }
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Place details failed');
              return res.json();
            })
            .then(function (place) {
              var components = place.addressComponents || [];
              var parsed = areaCityState(components, function (c) { return c.longText; });
              var label = parsed.main || fallbackLabel || place.formattedAddress;
              if (!label) throw new Error('No address found');

              /* Through applyResolved, with the place's own coordinates, so
                 a picked area is cached and announced exactly like a
                 detected one: the header and the weather card end up on the
                 same city instead of the card falling back to the section's
                 fallback one. */
              var picked = place.location || {};
              applyResolved(
                label,
                parsed.sub,
                typeof picked.latitude === 'number' ? picked.latitude : undefined,
                typeof picked.longitude === 'number' ? picked.longitude : undefined,
                parsed.city
              );

              picker.querySelectorAll('.site-location-address').forEach(function (l) { l.classList.remove('is-selected'); });
              searchInput.value = '';
              closeSuggestions();
              picker.classList.remove('is-open');
              locationBtn.setAttribute('aria-expanded', 'false');
            })
            .catch(function () {
              renderSuggestionsMessage('Couldn’t load that address — try again');
            });
        }

        var PIN_ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-7.4-7-12a7 7 0 1 1 14 0c0 4.6-7 12-7 12Z"/><circle cx="12" cy="9" r="2.5"/></svg>';

        /* One suggestion row. `onPick` runs on click and on Enter (the
           first row), so every source — Google, Photon, a pincode's post
           offices — is picked the same way. */
        function addSuggestion(mainText, secondaryText, onPick, selected) {
          var li = document.createElement('li');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'site-location-suggestion' + (selected ? ' is-selected' : '');
          btn.setAttribute('role', 'option');
          btn.innerHTML = PIN_ICON +
            '<span><span class="site-location-suggestion-main"></span>' +
            (secondaryText ? '<span class="site-location-suggestion-sub"></span>' : '') +
            '</span>';
          btn.querySelector('.site-location-suggestion-main').textContent = mainText;
          if (secondaryText) btn.querySelector('.site-location-suggestion-sub').textContent = secondaryText;
          /* Kept from reaching the document's outside-click handler: the
             pick may re-render this list ("Loading address…") before the
             event bubbles, and a detached target reads as a click outside
             the panel — which shut it while the lookup was still running. */
          btn.addEventListener('click', function (e) { e.stopPropagation(); onPick(e); });
          li.appendChild(btn);
          suggestionsList.appendChild(li);
          return btn;
        }

        function addSuggestionHead(text) {
          var li = document.createElement('li');
          li.className = 'site-location-suggestion-head';
          li.textContent = text;
          suggestionsList.appendChild(li);
        }

        function closePicker() {
          searchInput.value = '';
          closeSuggestions();
          picker.classList.remove('is-open');
          locationBtn.setAttribute('aria-expanded', 'false');
        }

        function clearSavedSelection() {
          picker.querySelectorAll('.site-location-address').forEach(function (l) { l.classList.remove('is-selected'); });
        }

        /* ---- Pincode: detected the moment the sixth digit lands ----------
           India Post names the post offices (areas) behind the number and
           the district they sit in; that is applied to the header straight
           away — no pick needed — and the areas are listed underneath so
           the shopper can narrow it down if they want to. OSM is asked in
           parallel for the pincode's coordinates (the weather card needs a
           position) and stands in for India Post if that is down. */
        var lastPincode = '';

        function runPincode(pin) {
          var seq = ++searchSeq;
          lastPincode = pin;
          renderSuggestionsMessage('Checking ' + pin + '…');

          var coords = null;
          var osm = lookupPincodeOSM(pin).catch(function () { return null; });
          osm.then(function (r) { if (r && isFinite(r.lat)) coords = r; });

          function apply(city, area, stateName) {
            var lat = coords ? coords.lat : undefined;
            var lon = coords ? coords.lon : undefined;
            applyResolved(city, (area && area !== city ? area + ' ' : '') + pin, lat, lon, city, { pincode: pin });
            clearSavedSelection();
          }

          lookupPincode(pin)
            .catch(function () { return null; })
            .then(function (res) {
              if (seq !== searchSeq) return;
              if (res && res.city) {
                apply(res.city, res.areas[0] && res.areas[0].area, res.state);
                suggestionsList.innerHTML = '';
                addSuggestionHead('Delivering to ' + res.city + (res.state ? ', ' + res.state : '') + ' · ' + pin);
                res.areas.slice(0, 8).forEach(function (a, i) {
                  addSuggestion(a.area, a.city + ' ' + pin, function () {
                    apply(a.city, a.area, a.state);
                    closePicker();
                  }, i === 0);
                });
                openSuggestions();
                /* Coordinates usually land a beat after India Post; when
                   they do, re-announce the same place with a position so
                   the weather card follows. */
                osm.then(function (r) {
                  if (seq !== searchSeq || !r || !isFinite(r.lat)) return;
                  var cur = null;
                  try { cur = JSON.parse(localStorage.getItem(LOCATION_CACHE_KEY) || 'null'); } catch (e) { cur = null; }
                  if (cur && cur.pincode === pin && cur.lat == null) {
                    applyResolved(cur.label, cur.subtext, r.lat, r.lon, cur.city, { pincode: pin });
                  }
                });
                return;
              }
              /* India Post had nothing (or was unreachable): OSM's answer
                 for the same number, if it has one. */
              return osm.then(function (r) {
                if (seq !== searchSeq) return;
                if (r && r.city) {
                  apply(r.city, r.area, r.state);
                  suggestionsList.innerHTML = '';
                  addSuggestionHead('Delivering to ' + r.city + (r.state ? ', ' + r.state : '') + ' · ' + pin);
                  addSuggestion(r.area || r.city, r.city + ' ' + pin, function () { closePicker(); }, true);
                  openSuggestions();
                  return;
                }
                renderSuggestionsMessage(res === null
                  ? 'Couldn’t check ' + pin + ' right now. Try again in a moment.'
                  : 'We couldn’t find pincode ' + pin + '. Check the number and try again.');
              });
            });
        }

        /* ---- Text search ---------------------------------------------------
           Google Places when the key works; Photon (OpenStreetMap) when it
           does not. On yourvro.com the key is refused for Places
           (API_KEY_HTTP_REFERRER_BLOCKED — the domain is not in the key's
           allowed referrers), which is why the search showed nothing. After
           one refusal the session stops asking Google and goes straight to
           Photon; add yourvro.com/* to the key's referrers in Google Cloud
           and Google is used again with no code change. */
        var googlePlacesDown = !searchGoogleMapsKey;

        function renderPhoton(query) {
          var seq = ++searchSeq;
          var url = 'https://photon.komoot.io/api/?q=' + encodeURIComponent(query) +
            '&limit=8&lang=en&bbox=68.1,6.5,97.5,35.7';
          fetchJSON(url, 8000)
            .then(function (data) {
              if (seq !== searchSeq) return;
              var feats = ((data && data.features) || []).filter(function (f) {
                return f.properties && (f.properties.countrycode || '').toUpperCase() === 'IN';
              });
              if (!feats.length) { renderSuggestionsMessage('No matches — try your 6-digit pincode'); return; }
              /* Areas before buildings: a shopper typing "Malviya Nagar"
                 wants the neighbourhood, not the school named after it.
                 Photon's `type` says which is which; order is otherwise
                 kept as ranked. */
              function rank(p) {
                if (p.osm_key === 'place' || p.osm_key === 'boundary') return 1;
                if (p.type === 'street') return 2;
                return 3;
              }
              feats = feats.map(function (f, i) { return { f: f, i: i, r: rank(f.properties) }; })
                .sort(function (a, b) { return a.r - b.r || a.i - b.i; })
                .map(function (x) { return x.f; });
              suggestionsList.innerHTML = '';
              var seen = {};
              feats.forEach(function (f) {
                var p = f.properties;
                /* OSM in India files wards under `district` and the tehsil
                   or taluk under `county`; `city` is the city when present. */
                var city = cleanCityName(p.city || p.town || p.county || '');
                var name = p.name || p.street || city;
                if (!name) return;
                var secondary = [city && city !== name ? city : '', p.state].filter(Boolean).join(', ');
                var key = name + '|' + secondary;
                if (seen[key]) return;
                seen[key] = true;
                var coords = (f.geometry && f.geometry.coordinates) || [];
                addSuggestion(name, secondary, function () {
                  var pin = PINCODE_RE.test(String(p.postcode || '')) ? String(p.postcode) : '';
                  /* The header's second line names an area, so a picked
                     building contributes the neighbourhood it sits in. */
                  var areaName = rank(p) === 1 ? name : (p.locality || name);
                  function finish(cityName) {
                    var label = cityName || city || p.state || name;
                    var area = areaName === label ? '' : areaName;
                    applyResolved(label, [area, pin].filter(Boolean).join(' '), coords[1], coords[0], label, { pincode: pin });
                    clearSavedSelection();
                    closePicker();
                  }
                  /* With a pincode, the city comes from India Post — the
                     same source the pincode box uses — so "Koramangala"
                     reads Bangalore rather than OSM's ward name. */
                  if (!pin) { finish(''); return; }
                  renderSuggestionsMessage('Loading address…');
                  lookupPincode(pin).then(function (res) { finish(res && res.city); }, function () { finish(''); });
                });
              });
              if (!suggestionsList.children.length) { renderSuggestionsMessage('No matches — try your 6-digit pincode'); return; }
              openSuggestions();
            })
            .catch(function () {
              if (seq !== searchSeq) return;
              renderSuggestionsMessage('Search unavailable right now — try your 6-digit pincode');
            });
        }

        function runAutocomplete(query) {
          if (googlePlacesDown) { renderPhoton(query); return; }
          var seq = ++searchSeq;
          fetch('https://places.googleapis.com/v1/places:autocomplete', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Goog-Api-Key': searchGoogleMapsKey
            },
            body: JSON.stringify({ input: query, includedRegionCodes: ['in'] })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Autocomplete failed');
              return res.json();
            })
            .then(function (data) {
              if (seq !== searchSeq) return; // a newer keystroke already superseded this request
              var suggestions = data.suggestions || [];
              if (!suggestions.length) {
                renderSuggestionsMessage('No matches — try your 6-digit pincode');
                return;
              }

              suggestionsList.innerHTML = '';
              suggestions.forEach(function (s) {
                var prediction = s.placePrediction;
                if (!prediction) return;
                var mainText = (prediction.structuredFormat && prediction.structuredFormat.mainText && prediction.structuredFormat.mainText.text) || prediction.text.text;
                var secondaryText = prediction.structuredFormat && prediction.structuredFormat.secondaryText && prediction.structuredFormat.secondaryText.text;
                addSuggestion(mainText, secondaryText, function () { selectSuggestion(prediction.placeId, mainText); });
              });
              openSuggestions();
            })
            .catch(function () {
              if (seq !== searchSeq) return;
              googlePlacesDown = true;
              renderPhoton(query);
            });
        }

        searchInput.addEventListener('input', function () {
          var query = searchInput.value.trim();
          clearTimeout(searchDebounce);

          if (!query) { lastPincode = ''; closeSuggestions(); return; }

          /* A pincode anywhere in what was typed ("302020", "Mansarovar
             302020") is looked up at once — no debounce, no Enter. */
          var pinMatch = query.match(/(?:^|\D)([1-9][0-9]{5})(?!\d)/);
          if (pinMatch) {
            if (pinMatch[1] !== lastPincode || suggestionsList.hidden) runPincode(pinMatch[1]);
            return;
          }
          lastPincode = '';

          /* Digits only, still short: say what we are waiting for rather
             than searching places for "3020". */
          if (/^\d+$/.test(query)) {
            ++searchSeq;
            if (query.length < 6) renderSuggestionsMessage('Enter your 6-digit pincode');
            else renderSuggestionsMessage('That doesn’t look like a pincode — it should be 6 digits.');
            return;
          }

          if (query.length < 3) { closeSuggestions(); return; }

          searchDebounce = setTimeout(function () { runAutocomplete(query); }, 300);
        });

        /* Enter picks the first (or highlighted) row; with a pincode that
           has already been applied it simply closes the panel. */
        searchInput.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          var first = suggestionsList.querySelector('.site-location-suggestion.is-selected') ||
            suggestionsList.querySelector('.site-location-suggestion');
          if (first) { first.click(); return; }
          var query = searchInput.value.trim();
          if (query.length >= 3 && !/^\d+$/.test(query)) { clearTimeout(searchDebounce); runAutocomplete(query); }
        });

        searchInput.addEventListener('focus', function () {
          if (searchInput.value.trim().length >= 3 && suggestionsList.innerHTML) openSuggestions();
        });
      }

      document.addEventListener('click', function (e) {
        if (!picker.contains(e.target) && e.target !== locationBtn && !locationBtn.contains(e.target)) {
          picker.classList.remove('is-open');
          locationBtn.setAttribute('aria-expanded', 'false');
          var list = picker.querySelector('.site-location-suggestions');
          if (list) { list.hidden = true; list.innerHTML = ''; }
        }
      });
    });

    /* A cached city goes stale — the shopper travels, or simply comes back a
       week later — and the header used to answer that by naming the theme's
       fallback city, which is a city nobody chose and nobody detected. Read
       the position again instead, but only where the browser will hand it
       over without a dialog: a shopper who granted the permission gets their
       real city back, and everyone else keeps the last one we knew.

       Silent, so nothing on screen changes unless there is a better answer,
       and no one is asked for anything they did not ask for — whether to
       prompt a first-time visitor at all stays the weather section's
       decision, and it asks once. */
    function refreshStaleLocation() {
      var entry = null;
      try { entry = JSON.parse(localStorage.getItem(LOCATION_CACHE_KEY) || 'null'); } catch (e) { entry = null; }
      var fresh = entry && entry.label && entry.savedAt && (Date.now() - entry.savedAt) < LOCATION_CACHE_MS;
      if (fresh) return;

      if (!navigator.geolocation) return;

      var query = null;
      try {
        if (navigator.permissions && navigator.permissions.query) {
          query = navigator.permissions.query({ name: 'geolocation' });
        }
      } catch (e) { query = null; }
      /* No answer means we would have to ask to find out, which is exactly
         what this must not do. Safari lands here. */
      if (!query || typeof query.then !== 'function') return;

      query
        .then(function (status) {
          if (status && status.state === 'granted') detectLocation(locationBtns[0], true);
        })
        .catch(function () { /* browser will not say; leave the header alone */ });
    }

    refreshStaleLocation();
  }

  /* ---------------------------------------------------------
     Header predictive search — Figma "Search · Entry" (recent +
     trending, empty query) and "Search · Typing" (live query
     suggestions + up to 4 matching products via Shopify's
     predictive search JSON API).
  --------------------------------------------------------- */
  (function () {
    var group = document.querySelector('[data-search-group]');
    if (!group) return;

    var form = group.querySelector('[data-search-form]');
    var input = group.querySelector('[data-search-input]');
    var panel = group.querySelector('[data-search-panel]');
    var recentSection = panel.querySelector('[data-search-section="recent"]');
    var recentList = panel.querySelector('[data-search-recent-list]');
    var trendingSection = panel.querySelector('[data-search-section="trending"]');
    var liveSection = panel.querySelector('[data-search-section="live"]');
    var liveList = panel.querySelector('[data-search-live-list]');
    var RECENT_KEY = 'vro_recent_searches';
    var RECENT_MAX = 4;
    var debounce;
    var fetchToken = 0;

    function getRecent() {
      try {
        var raw = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
        return Array.isArray(raw) ? raw : [];
      } catch (e) {
        return [];
      }
    }

    function saveRecent(term) {
      term = term.trim();
      if (!term) return;
      try {
        var list = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
        list.unshift(term);
        localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
      } catch (e) { /* localStorage unavailable — recent search just won't persist */ }
    }

    function clockIconSvg() {
      return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4v6h6"/><path d="M3.5 13a9 9 0 1 0 2.6-6.4L1 10"/><path d="M12 8v5l3 2"/></svg>';
    }
    function searchIconSvg() {
      return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
    }

    function renderRecent() {
      var terms = getRecent();
      recentSection.hidden = terms.length === 0;
      recentList.innerHTML = terms.map(function (term) {
        return '<button type="button" class="site-search-recent-item" data-search-fill="' + escapeHtml(term) + '">' +
          clockIconSvg() + '<span>' + escapeHtml(term) + '</span></button>';
      }).join('');
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function showEntryState() {
      renderRecent();
      if (trendingSection) trendingSection.hidden = false;
      liveSection.hidden = true;
      liveList.innerHTML = '';
    }

    function showLiveState(html) {
      recentSection.hidden = true;
      if (trendingSection) trendingSection.hidden = true;
      liveSection.hidden = false;
      liveList.innerHTML = html;
    }

    function runPredictiveSearch(query) {
      var token = ++fetchToken;
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,query&resources[limit]=4&resources[options][unavailable_products]=last')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (token !== fetchToken) return; // a newer keystroke already superseded this fetch
          var resources = (data && data.resources && data.resources.results) || {};
          var queries = resources.queries || [];
          var products = resources.products || [];

          if (queries.length === 0 && products.length === 0) {
            showLiveState('<p class="site-search-empty-note">No matches yet — press Enter to search "' + escapeHtml(query) + '" anyway</p>');
            return;
          }

          var html = '';
          if (queries.length > 0) {
            html += queries.map(function (q) {
              return '<button type="button" class="site-search-suggestion-item" data-search-fill="' + escapeHtml(q.text) + '">' +
                searchIconSvg() + '<span>' + (q.styled_text || escapeHtml(q.text)) + '</span></button>';
            }).join('');
          }
          if (products.length > 0) {
            html += '<p class="site-search-panel-label" style="margin-top:12px;">In products</p>';
            html += products.map(function (p) {
              return '<a href="' + p.url + '" class="site-search-product-row">' +
                (p.image ? '<img class="site-search-product-thumb" src="' + p.image + '" alt="" loading="lazy">' : '<span class="site-search-product-thumb"></span>') +
                '<span class="site-search-product-info">' +
                  '<span class="site-search-product-title">' + escapeHtml(p.title) + '</span>' +
                  (p.vendor ? '<span class="site-search-product-meta">' + escapeHtml(p.vendor) + '</span>' : '') +
                '</span>' +
                '<span class="site-search-product-price">' + (p.price ? '₹' + Math.round(parseFloat(p.price)) : '') + '</span>' +
              '</a>';
            }).join('');
          }
          showLiveState(html);
        })
        .catch(function () {
          if (token !== fetchToken) return;
          showLiveState('<p class="site-search-empty-note">Couldn’t load suggestions — press Enter to search anyway</p>');
        });
    }

    function openPanel() {
      panel.hidden = false;
      var query = input.value.trim();
      if (query) { showLiveState(liveList.innerHTML || ''); runPredictiveSearch(query); }
      else { showEntryState(); }
    }
    function closePanel() { panel.hidden = true; }

    input.addEventListener('focus', openPanel);
    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounce);
      if (!query) { showEntryState(); return; }
      debounce = setTimeout(function () { runPredictiveSearch(query); }, 250);
    });

    panel.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-search-fill]');
      if (!trigger) return;
      var term = trigger.getAttribute('data-search-fill');
      input.value = term;
      saveRecent(term);
      form.submit();
    });

    form.addEventListener('submit', function () {
      saveRecent(input.value);
    });

    document.addEventListener('click', function (e) {
      if (!group.contains(e.target)) closePanel();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });
  })();

  /* ---------------------------------------------------------
     Search results: infinite scroll. The sentinel below the grid
     carries the next page's URL (paginate.next.url); scrolling it
     into view re-fetches that page via the Section Rendering API
     and appends its cards, then swaps in whatever new sentinel
     that fetch rendered — stops on its own once a fetched page
     has none (i.e. it was the last page).
  --------------------------------------------------------- */
  (function () {
    var page = document.querySelector('.search-page[data-section-id]');
    if (!page) return;
    var sectionId = page.getAttribute('data-section-id');
    var loading = false;
    var observer = null;
    /* The next page, asked for as soon as the one before it lands rather
       than when the shopper reaches the bottom — the render of a search
       page is slow enough that waiting for the scroll meant waiting on a
       spinner every 24 products. */
    var prefetched = {};

    function fetchPage(url) {
      if (!prefetched[url]) {
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        prefetched[url] = fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId))
          .then(function (res) {
            if (!res.ok) throw new Error('search page ' + res.status);
            return res.text();
          })
          .catch(function (err) { delete prefetched[url]; throw err; });
      }
      return prefetched[url];
    }

    function watch(sentinel) {
      if (!sentinel) return;
      if (!observer) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadNext();
          });
        }, { rootMargin: '1500px 0px' });
      }
      observer.observe(sentinel);
      var url = sentinel.getAttribute('data-next-url');
      if (url) fetchPage(url).catch(function () {});
    }

    function loadNext() {
      var sentinel = page.querySelector('[data-search-sentinel]');
      var grid = page.querySelector('[data-search-grid]');
      if (!sentinel || !grid || loading) return;
      var url = sentinel.getAttribute('data-next-url');
      if (!url) return;

      loading = true;
      sentinel.classList.add('is-loading');

      fetchPage(url)
        .then(function (html) {
          delete prefetched[url];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-search-grid]');
          if (newGrid) {
            while (newGrid.firstChild) grid.appendChild(newGrid.firstChild);
          }

          if (observer) observer.unobserve(sentinel);
          var newSentinel = doc.querySelector('[data-search-sentinel]');
          if (newSentinel) {
            sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
            sentinel.classList.remove('is-loading');
            loading = false;
            watch(sentinel);
            /* Still in reach after the append: the observer does not fire
               again for an element that never left, so carry on. */
            if (sentinel.getBoundingClientRect().top < window.innerHeight + 1500) loadNext();
          } else {
            sentinel.remove();
            loading = false;
          }
        })
        .catch(function () {
          loading = false;
          sentinel.classList.remove('is-loading');
        });
    }

    watch(page.querySelector('[data-search-sentinel]'));
  })();

  /* ---------------------------------------------------------
     Fashion-week size-quiz rail (sections/fashion-week-rail.liquid only —
     scoped to .fashion-week-rail, so this never touches feed-rail.liquid's
     own cards elsewhere on the site).

     Every tab's rail-scroll opens with a size-quiz card (leading card, one
     copy per tab so it scrolls with that tab's row). Picking a size:
       - hides cards in every tab that don't carry that size in stock
       - re-points each remaining card's (+) button at that size's variant
         (skipping the quick-add modal, since the size is now known)
     "I'm not sure" clears the filter and restores the original (+) button.
     Filtering all tabs up front (not just the visible one) means no extra
     listener is needed when Bootstrap swaps the active tab-pane.
  --------------------------------------------------------- */
  document.querySelectorAll('.fashion-week-rail').forEach(function (rail) {
    var selectedSize = null;

    function variantForSize(card, size) {
      var pairs = (card.getAttribute('data-size-variants') || '').split('|');
      for (var i = 0; i < pairs.length; i++) {
        var parts = pairs[i].split(':');
        if (parts[0] === size) return parts[1];
      }
      return null;
    }

    function applySize(size) {
      selectedSize = size;

      rail.querySelectorAll('.size-quiz-btn').forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(size !== null && btn.getAttribute('data-size-value') === size));
      });

      rail.querySelectorAll('.rail-scroll .feed-card').forEach(function (card) {
        var addBtn = card.querySelector('.feed-add-btn');

        if (!size) {
          card.hidden = false;
          if (addBtn && addBtn.hasAttribute('data-orig-quick-add')) {
            addBtn.setAttribute('data-quick-add-handle', addBtn.getAttribute('data-orig-quick-add'));
            addBtn.removeAttribute('data-add-variant');
          }
          return;
        }

        var sizes = (card.getAttribute('data-sizes') || '').split(',').filter(Boolean);
        var match = sizes.indexOf(size) > -1;
        card.hidden = !match;
        if (!match || !addBtn) return;

        var variantId = variantForSize(card, size);
        if (!variantId) return;
        if (addBtn.hasAttribute('data-quick-add-handle') && !addBtn.hasAttribute('data-orig-quick-add')) {
          addBtn.setAttribute('data-orig-quick-add', addBtn.getAttribute('data-quick-add-handle'));
        }
        addBtn.removeAttribute('data-quick-add-handle');
        addBtn.setAttribute('data-add-variant', variantId);
      });
    }

    rail.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('.size-quiz-btn');
      if (sizeBtn) {
        var value = sizeBtn.getAttribute('data-size-value');
        applySize(selectedSize === value ? null : value);
        return;
      }
      if (e.target.closest('[data-size-reset]')) applySize(null);
    });
  });
});

/* ---------------------------------------------------------------
   The card's hover picture, fetched when there is a pointer to hover.

   Every product card carries a second image that crossfades in on hover.
   It was a real <img src>, so a phone downloaded it too — one extra
   request per card, for a picture no touch screen can show. On a thin
   connection that is what leaves a shelf drawing alt text where the
   photographs should be.

   The markup ships it as data-hover-src (snippets/feed-product-card.liquid)
   and this hands it over the first time a pointer actually enters the
   card. Delegated, so cards the rails and quizzes add later are covered
   without rebinding, and guarded by the same (hover: hover) the crossfade
   itself is guarded by. Once loaded, the attributes are dropped and the
   browser does the rest.
--------------------------------------------------------------- */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;

  function wake(wrap) {
    var img = wrap.querySelector('img[data-hover-src]');
    if (!img) return;
    var srcset = img.getAttribute('data-hover-srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.setAttribute('src', img.getAttribute('data-hover-src'));
    img.removeAttribute('data-hover-src');
    img.removeAttribute('data-hover-srcset');
  }

  ['pointerenter', 'focusin'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var wrap = e.target && e.target.closest
        ? e.target.closest('.feed-card-image-wrap')
        : null;
      if (wrap) wake(wrap);
    }, true);
  });
})();

/* ---------------------------------------------------------
   Price filter boxes are only sent when they hold a number.
   snippets/collection-filters.liquid and plp-filter-sheet.liquid render an
   empty box without its `name`, so a filter applied beside it does not
   carry filter.v.price.gte=&filter.v.price.lte= — which Shopify reads as a
   bound of 0, returning nothing. Typing a number gives the box its name
   (kept in data-price-param); clearing it takes the name away again, so
   the bound is dropped rather than sent empty. Delegated from the
   document, so the bar and sheet the filter scripts swap in keep working.
--------------------------------------------------------- */
(function () {
  function sync(input) {
    var param = input.getAttribute('data-price-param');
    if (!param) return;
    if (String(input.value).trim() === '') input.removeAttribute('name');
    else input.setAttribute('name', param);
  }
  ['input', 'change'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target && e.target.matches && e.target.matches('input[data-price-param]')) sync(e.target);
    }, true);
  });
})();

/* The Manifest AI chatbot app (app embed) adds its floating launcher to
   the page itself, with markup the theme doesn't control. Its elements
   are marked here so assets/custom.css can hide them wherever the bottom
   nav is drawn (below 992px): the nav's diamond is the way in there. The
   app adds them after load, so new arrivals are watched for too. */
(function () {
  /* Manifest AI is now "Manifest AI by BIK". */
  var APP = /manifest|(^|[-_ ])bik([-_ ]|$)|chatbot/i;
  var CHATTY = /chat|bot|widget|launcher|bik|manifest/i;
  function named(el) {
    var cls = typeof el.className === 'string' ? el.className : '';
    return [el.id || '', cls, el.getAttribute('src') || '', el.getAttribute('title') || '', el.tagName].join(' ');
  }
  function isApp(el) {
    if (!el || el.nodeType !== 1) return false;
    if (/^(LINK|SCRIPT|STYLE|META|NOSCRIPT|TEMPLATE)$/.test(el.tagName)) return false;
    if (el.closest('.glass-bottom-nav, .chat-dock, main, header, footer, [id^="shopify-section-"]')) return false;
    if (APP.test(named(el))) return true;
    var frame = el.tagName === 'IFRAME' ? el : (el.querySelector && el.querySelector('iframe'));
    if (frame && APP.test(named(frame))) return true;
    /* Failing a name: a floating button the app pinned to the bottom-right
       corner, with a chat-like name or a frame of its own. */
    var cs = window.getComputedStyle(el);
    if (cs.position !== 'fixed' || cs.display === 'none') return false;
    var r = el.getBoundingClientRect();
    if (!r.width || r.width > 160 || r.height > 160) return false;
    if (r.right < window.innerWidth - 120 || r.bottom < window.innerHeight - 160) return false;
    return !!frame || CHATTY.test(named(el));
  }
  function scan(root) {
    Array.prototype.forEach.call((root || document.body).children, function (el) {
      if (isApp(el)) el.classList.add('vro-app-launcher-hide');
    });
  }
  function start() {
    if (!document.body) return;
    scan(document.body);
    /* The corner check needs the app's button laid out; look again once
       it has had time to arrive. */
    window.addEventListener('load', function () {
      scan(document.body);
      setTimeout(function () { scan(document.body); }, 2000);
      setTimeout(function () { scan(document.body); }, 6000);
    });
    if (!window.MutationObserver) return;
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.parentNode === document.body && isApp(n)) n.classList.add('vro-app-launcher-hide');
        });
      });
    }).observe(document.body, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
